import { Software } from '@/types/software';
import plantLibrary from '@/assets/logos/plant_library.png';

export const obsoleteSoftware: Software[] = [
  {
    id: '1',
    name: 'Internet Explorer',
    logo: '🌐',
    launchDate: '1995-08-16',
    endDate: '2022-06-15',
    description: "Microsoft's web browser that dominated the early internet",
  },
  {
    id: '2',
    name: 'Adobe Flash Player',
    logo: '⚡',
    launchDate: '1996-05-30',
    endDate: '2020-12-31',
    description: 'Multimedia platform for animations and interactive content',
  },
  {
    id: '3',
    name: 'Windows XP',
    logo: '🪟',
    launchDate: '2001-10-25',
    endDate: '2014-04-08',
    description: "Microsoft's beloved operating system",
  },
  {
    id: '4',
    name: 'MSN Messenger',
    logo: '💬',
    launchDate: '1999-07-22',
    endDate: '2013-04-08',
    description: 'Instant messaging service that connected millions',
  },
  {
    id: '5',
    name: 'Winamp',
    logo: '🎵',
    launchDate: '1997-04-21',
    endDate: '2013-12-20',
    description: "It really whipped the llama's ass",
  },
  {
    id: '6',
    name: 'Google Reader',
    logo: '📰',
    launchDate: '2005-10-07',
    endDate: '2013-07-01',
    description: 'RSS feed reader that organized the web',
  },
  {
    id: '7',
    name: 'BlackBerry OS',
    logo: '📱',
    launchDate: '1999-01-19',
    endDate: '2022-01-04',
    description: 'Mobile operating system for business professionals',
  },
  {
    id: '8',
    name: 'Yahoo! Answers',
    logo: '❓',
    launchDate: '2005-06-28',
    endDate: '2021-05-04',
    description: 'Question and answer platform',
  },
  {
    id: '9',
    name: 'Vine',
    logo: '🎬',
    launchDate: '2013-01-24',
    endDate: '2017-01-17',
    description: '6-second video sharing app',
  },
  {
    id: '10',
    name: 'Google+',
    logo: '➕',
    launchDate: '2011-06-28',
    endDate: '2019-04-02',
    description: "Google's attempt at social networking",
  },
  {
    id: '11',
    name: 'Napster',
    logo: '🎧',
    launchDate: '1999-06-01',
    endDate: '2001-07-11',
    description: 'Pioneer of peer-to-peer file sharing',
  },
  {
    id: '12',
    name: 'Windows Vista',
    logo: '💻',
    launchDate: '2006-11-30',
    endDate: '2017-04-11',
    description: "Microsoft's controversial operating system",
  },
  {
    id: '13',
    name: 'Clippy',
    logo: '📎',
    launchDate: '1997-08-19',
    endDate: '2007-01-30',
    description: "Microsoft Office's helpful assistant",
  },
  {
    id: '14',
    name: 'Geocities',
    logo: '🏠',
    launchDate: '1994-11-15',
    endDate: '2009-10-26',
    description: 'Web hosting service for personal websites',
  },
  {
    id: '15',
    name: 'Friendster',
    logo: '👥',
    launchDate: '2002-03-22',
    endDate: '2015-06-14',
    description: 'One of the first social networking sites',
  },
  {
    id: '16',
    name: 'MySpace',
    logo: '🎨',
    launchDate: '2003-08-01',
    endDate: '2019-03-12',
    description: 'Social networking site with customizable profiles',
  },
  {
    id: '17',
    name: 'Orkut',
    logo: '🔵',
    launchDate: '2004-01-24',
    endDate: '2014-09-30',
    description: "Google's social networking experiment",
  },
  {
    id: '18',
    name: 'Windows Phone',
    logo: '📲',
    launchDate: '2010-10-21',
    endDate: '2017-10-08',
    description: "Microsoft's mobile operating system",
  },
  {
    id: '19',
    name: 'Macromedia Director',
    logo: '🎭',
    launchDate: '1985-01-01',
    endDate: '2017-02-01',
    description: 'Multimedia authoring platform',
  },
  {
    id: '20',
    name: 'Real Player',
    logo: '▶️',
    launchDate: '1995-04-01',
    endDate: '2018-12-01',
    description: 'Media player for streaming audio and video',
  },
  {
    id: '21',
    name: 'Lotus Notes',
    logo: '📧',
    launchDate: '1989-12-01',
    endDate: '2018-09-30',
    description: 'Enterprise email and collaboration platform',
  },
  {
    id: '22',
    name: 'Netscape Navigator',
    logo: '🧭',
    launchDate: '1994-12-15',
    endDate: '2008-03-01',
    description: 'Pioneer web browser of the 90s',
  },
  {
    id: '23',
    name: 'WordPerfect',
    logo: '📝',
    launchDate: '1979-03-01',
    endDate: '2020-04-30',
    description: 'Word processor that ruled before Microsoft Word',
  },
  {
    id: '24',
    name: 'Adobe Shockwave',
    logo: '🌊',
    launchDate: '1995-08-01',
    endDate: '2019-04-09',
    description: 'Multimedia platform for interactive content',
  },
  {
    id: '25',
    name: 'ICQ',
    logo: '💭',
    launchDate: '1996-11-15',
    endDate: '2021-06-26',
    description: 'I Seek You - early instant messaging',
  },
  {
    id: '26',
    name: 'Kazaa',
    logo: '🔄',
    launchDate: '2001-03-01',
    endDate: '2012-08-01',
    description: 'Peer-to-peer file sharing network',
  },
  {
    id: '27',
    name: 'Windows ME',
    logo: '💿',
    launchDate: '2000-09-14',
    endDate: '2006-07-11',
    description: 'Windows Millennium Edition',
  },
  {
    id: '28',
    name: 'Palm OS',
    logo: '🌴',
    launchDate: '1996-04-01',
    endDate: '2011-05-18',
    description: 'Operating system for Palm PDAs',
  },
  {
    id: '29',
    name: 'Bebo',
    logo: '🎪',
    launchDate: '2005-01-01',
    endDate: '2013-06-01',
    description: 'Social networking site popular in UK and Ireland',
  },
  {
    id: '30',
    name: 'Windows Mobile',
    logo: '📱',
    launchDate: '2000-04-19',
    endDate: '2010-10-21',
    description: "Microsoft's early mobile operating system",
  },
  {
    id: '31',
    name: 'Google Wave',
    logo: '🌊',
    launchDate: '2009-05-28',
    endDate: '2012-04-30',
    description: 'Real-time collaborative communication platform',
  },
  {
    id: '32',
    name: 'Adobe Director',
    logo: '🎬',
    launchDate: '1985-01-01',
    endDate: '2017-02-01',
    description: 'Multimedia authoring tool',
  },
  {
    id: '34',
    name: 'HyperCard',
    logo: '🃏',
    launchDate: '1987-08-11',
    endDate: '2004-03-01',
    description: "Apple's hypermedia program",
  },
  {
    id: '35',
    name: 'Quattro Pro',
    logo: '📊',
    launchDate: '1989-01-01',
    endDate: '2020-04-30',
    description: 'Spreadsheet application',
  },
  {
    id: '36',
    name: 'dBASE',
    logo: '🗃️',
    launchDate: '1979-01-01',
    endDate: '2015-09-01',
    description: 'Database management system',
  },
  {
    id: '37',
    name: 'Symbian',
    logo: '📱',
    launchDate: '1998-06-24',
    endDate: '2014-01-01',
    description: 'Mobile operating system for smartphones',
  },
  {
    id: '38',
    name: 'Adobe GoLive',
    logo: '🌐',
    launchDate: '1996-05-01',
    endDate: '2008-04-30',
    description: 'Web development tool',
  },
  {
    id: '39',
    name: 'Corel Draw X3',
    logo: '🎨',
    launchDate: '2006-01-01',
    endDate: '2016-04-01',
    description: 'Vector graphics editor',
  },
  {
    id: '40',
    name: 'Norton Ghost',
    logo: '👻',
    launchDate: '1996-08-19',
    endDate: '2013-04-30',
    description: 'Disk cloning and backup tool',
  },
  {
    id: '41',
    name: 'mIRC',
    logo: '💬',
    launchDate: '1995-02-28',
    endDate: '2020-01-01',
    description: 'Internet Relay Chat client',
  },
  {
    id: '42',
    name: 'WinRAR 3.x',
    logo: '📦',
    launchDate: '2002-10-29',
    endDate: '2013-09-29',
    description: 'File archiver and compressor',
  },
  {
    id: '43',
    name: 'QuickTime',
    logo: '🎬',
    launchDate: '1991-12-02',
    endDate: '2018-04-14',
    description: "Apple's multimedia framework",
  },
  {
    id: '44',
    name: 'Windows 98',
    logo: '🖥️',
    launchDate: '1998-06-25',
    endDate: '2006-07-11',
    description: 'Microsoft Windows operating system',
  },
  {
    id: '45',
    name: 'Adobe PageMaker',
    logo: '📄',
    launchDate: '1985-07-01',
    endDate: '2004-08-31',
    description: 'Desktop publishing software',
  },
  {
    id: '46',
    name: 'Lotus 1-2-3',
    logo: '🔢',
    launchDate: '1983-01-26',
    endDate: '2013-05-14',
    description: 'Spreadsheet program for DOS and Windows',
  },
  {
    id: '47',
    name: 'Windows 2000',
    logo: '💾',
    launchDate: '2000-02-17',
    endDate: '2010-07-13',
    description: 'Business-oriented operating system',
  },
  {
    id: '48',
    name: 'Adobe Fireworks',
    logo: '🎆',
    launchDate: '1998-04-01',
    endDate: '2013-05-06',
    description: 'Bitmap and vector graphics editor',
  },
  {
    id: '49',
    name: 'Picasa',
    logo: '📸',
    launchDate: '2002-07-13',
    endDate: '2016-05-01',
    description: 'Image organizer and image viewer',
  },
  {
    id: '50',
    name: 'Google Desktop',
    logo: '🔍',
    launchDate: '2004-10-14',
    endDate: '2011-09-14',
    description: 'Desktop search application',
  },
  {
    id: '51',
    name: 'Windows 95',
    logo: '🏠',
    launchDate: '1995-08-24',
    endDate: '2001-12-31',
    description: 'Revolutionary Windows operating system',
  },
  {
    id: '52',
    name: 'AIM (AOL Instant Messenger)',
    logo: '📢',
    launchDate: '1997-05-01',
    endDate: '2017-12-15',
    description: 'Pioneer of instant messaging',
  },
  {
    id: '53',
    name: 'Adobe Flash',
    logo: '⚡',
    launchDate: '1996-05-30',
    endDate: '2020-12-31',
    description: 'Revolutionary web animation platform',
  },
  {
    id: '54',
    name: 'Sony VAIO Care',
    logo: '💻',
    launchDate: '2008-01-01',
    endDate: '2020-03-31',
    description: 'System maintenance software for VAIO PCs',
  },
  {
    id: '55',
    name: 'Windows Movie Maker',
    logo: '🎬',
    launchDate: '2000-09-14',
    endDate: '2017-01-10',
    description: 'Built-in video editing software',
  },
  {
    id: '56',
    name: 'MSN Music',
    logo: '🎵',
    launchDate: '2004-10-01',
    endDate: '2008-11-14',
    description: "Microsoft's digital music service",
  },
  {
    id: '57',
    name: 'Yahoo! Messenger',
    logo: '💬',
    launchDate: '1998-06-21',
    endDate: '2018-07-17',
    description: 'Early instant messaging platform',
  },
  {
    id: '58',
    name: 'Skype for Business',
    logo: '📞',
    launchDate: '2015-04-14',
    endDate: '2021-07-31',
    description: 'Enterprise communication platform',
  },
  {
    id: '59',
    name: 'Adobe Acrobat 3D',
    logo: '📄',
    launchDate: '2005-01-01',
    endDate: '2013-05-07',
    description: '3D PDF creation tool',
  },
  {
    id: '60',
    name: 'Google Buzz',
    logo: '🐝',
    launchDate: '2010-02-09',
    endDate: '2011-12-15',
    description: 'Social networking attempt within Gmail',
  },
  {
    id: '61',
    name: 'Windows Sidebar',
    logo: '📊',
    launchDate: '2006-11-30',
    endDate: '2012-07-10',
    description: 'Desktop gadgets platform',
  },
  {
    id: '62',
    name: 'iTunes Ping',
    logo: '🎵',
    launchDate: '2010-09-01',
    endDate: '2012-09-30',
    description: "Apple's social music discovery service",
  },
  {
    id: '63',
    name: 'Microsoft Zune Software',
    logo: '🎶',
    launchDate: '2006-11-14',
    endDate: '2015-11-15',
    description: 'Media management for Zune devices',
  },
  {
    id: '64',
    name: 'Adobe AIR',
    logo: '🌬️',
    launchDate: '2008-02-25',
    endDate: '2019-05-01',
    description: 'Cross-platform runtime environment',
  },
  {
    id: '65',
    name: 'Windows 7 Gadgets',
    logo: '🔧',
    launchDate: '2009-10-22',
    endDate: '2012-07-10',
    description: 'Desktop widget platform',
  },
  {
    id: '66',
    name: 'Google Notebook',
    logo: '📔',
    launchDate: '2006-05-10',
    endDate: '2012-07-13',
    description: 'Web-based note-taking service',
  },
  {
    id: '67',
    name: 'Delicious (del.icio.us)',
    logo: '🔖',
    launchDate: '2003-09-01',
    endDate: '2017-06-15',
    description: 'Social bookmarking service',
  },
  {
    id: '68',
    name: 'Microsoft Expression Web',
    logo: '🌐',
    launchDate: '2006-12-01',
    endDate: '2012-12-01',
    description: 'Web design and development tool',
  },
  {
    id: '69',
    name: 'Adobe Flash Catalyst',
    logo: '⚡',
    launchDate: '2010-04-12',
    endDate: '2012-05-06',
    description: 'Interaction design tool',
  },
  {
    id: '70',
    name: 'Google Health',
    logo: '🏥',
    launchDate: '2008-05-20',
    endDate: '2012-01-01',
    description: 'Personal health record service',
  },
  {
    id: '71',
    name: 'Windows Live Writer',
    logo: '✍️',
    launchDate: '2006-08-14',
    endDate: '2017-01-10',
    description: 'Desktop blog publishing application',
  },
  {
    id: '72',
    name: 'Adobe Story',
    logo: '📝',
    launchDate: '2010-06-01',
    endDate: '2019-01-22',
    description: 'Collaborative script development tool',
  },
  {
    id: '73',
    name: 'Microsoft Office Groove',
    logo: '🎵',
    launchDate: '2007-01-30',
    endDate: '2010-05-12',
    description: 'Collaborative workspace software',
  },
  {
    id: '74',
    name: 'Google Video',
    logo: '📹',
    launchDate: '2005-01-25',
    endDate: '2012-08-20',
    description: 'Video hosting service',
  },
  {
    id: '75',
    name: 'Adobe Encore',
    logo: '💿',
    launchDate: '2003-09-01',
    endDate: '2017-01-09',
    description: 'DVD and Blu-ray authoring software',
  },
  {
    id: '76',
    name: 'Microsoft FrontPage',
    logo: '🌐',
    launchDate: '1995-10-01',
    endDate: '2006-12-01',
    description: 'WYSIWYG HTML editor',
  },
  {
    id: '77',
    name: 'Sun StarOffice',
    logo: '☀️',
    launchDate: '1985-01-01',
    endDate: '2010-09-13',
    description: 'Office productivity suite',
  },
  {
    id: '79',
    name: 'Adobe Flash Media Server',
    logo: '📡',
    launchDate: '2002-07-01',
    endDate: '2021-07-30',
    description: 'Media streaming server',
  },
  {
    id: '80',
    name: 'Google Code',
    logo: '💻',
    launchDate: '2006-07-27',
    endDate: '2016-01-25',
    description: 'Code hosting and project management',
  },
  {
    id: '81',
    name: 'Microsoft PhotoDraw',
    logo: '🎨',
    launchDate: '1998-01-01',
    endDate: '2003-01-01',
    description: 'Vector and bitmap graphics editor',
  },
  {
    id: '83',
    name: 'Windows Live Spaces',
    logo: '🌌',
    launchDate: '2004-12-01',
    endDate: '2011-03-16',
    description: 'Personal web space and blogging service',
  },
  {
    id: '84',
    name: 'Adobe Contribute',
    logo: '🤝',
    launchDate: '2003-07-01',
    endDate: '2017-01-09',
    description: 'Website content management tool',
  },
  {
    id: '85',
    name: 'Microsoft Bob',
    logo: '👨',
    launchDate: '1995-03-11',
    endDate: '1996-08-01',
    description: 'Simplified desktop interface',
  },
  {
    id: '86',
    name: 'Google Lively',
    logo: '🎮',
    launchDate: '2008-07-08',
    endDate: '2008-12-31',
    description: '3D virtual world browser plugin',
  },
  {
    id: '87',
    name: 'Windows Live OneCare',
    logo: '🛡️',
    launchDate: '2005-05-31',
    endDate: '2009-06-30',
    description: 'Computer security and performance service',
  },
  {
    id: '88',
    name: 'Adobe Device Central',
    logo: '📱',
    launchDate: '2007-04-16',
    endDate: '2015-01-13',
    description: 'Mobile device emulation and testing',
  },
  {
    id: '89',
    name: 'Microsoft Streets & Trips',
    logo: '🗺️',
    launchDate: '1998-01-01',
    endDate: '2014-08-31',
    description: 'Trip planning and mapping software',
  },
  {
    id: '90',
    name: 'Google Jaiku',
    logo: '🐦',
    launchDate: '2006-02-01',
    endDate: '2012-01-15',
    description: 'Microblogging and lifestreaming service',
  },
  {
    id: '92',
    name: 'Windows Live Family Safety',
    logo: '👨‍👩‍👧‍👦',
    launchDate: '2007-01-30',
    endDate: '2012-08-07',
    description: 'Parental control software',
  },
  {
    id: '93',
    name: 'Microsoft Expression Blend',
    logo: '🎨',
    launchDate: '2007-08-01',
    endDate: '2012-12-01',
    description: 'User interface design tool',
  },
  {
    id: '94',
    name: 'Google Knol',
    logo: '📚',
    launchDate: '2008-07-23',
    endDate: '2012-05-01',
    description: 'Collaborative knowledge platform',
  },
  {
    id: '95',
    name: 'Adobe Version Cue',
    logo: '📋',
    launchDate: '2003-09-01',
    endDate: '2012-05-07',
    description: 'File versioning and collaboration',
  },
  {
    id: '96',
    name: 'Microsoft Office Picture Manager',
    logo: '🖼️',
    launchDate: '2003-08-19',
    endDate: '2016-01-12',
    description: 'Image editing and management tool',
  },
  {
    id: '97',
    name: 'Google Page Creator',
    logo: '📄',
    launchDate: '2006-02-23',
    endDate: '2009-09-01',
    description: 'Simple website creation tool',
  },
  {
    id: '98',
    name: 'Adobe Atmosphere',
    logo: '🌍',
    launchDate: '2001-02-01',
    endDate: '2004-12-01',
    description: '3D virtual world creation tool',
  },
  {
    id: '99',
    name: 'Windows Live Mesh',
    logo: '🔗',
    launchDate: '2008-04-23',
    endDate: '2013-02-13',
    description: 'File synchronization service',
  },
  {
    id: '100',
    name: 'Microsoft Virtual PC',
    logo: '💻',
    launchDate: '2001-06-01',
    endDate: '2011-04-01',
    description: 'Desktop virtualization software',
  },
  {
    id: '101',
    name: 'Adobe ColdFusion Builder',
    logo: '🔧',
    launchDate: '2010-03-22',
    endDate: '2016-07-11',
    description: 'IDE for ColdFusion development',
  },
  {
    id: '102',
    name: 'Google SearchWiki',
    logo: '🔍',
    launchDate: '2008-11-20',
    endDate: '2010-03-01',
    description: 'Collaborative search result customization',
  },
  {
    id: '103',
    name: 'Microsoft Office Binder',
    logo: '📁',
    launchDate: '1995-08-24',
    endDate: '2003-08-19',
    description: 'Document collection organizer',
  },
  {
    id: '104',
    name: 'Adobe Bridge CS6',
    logo: '🌉',
    launchDate: '2012-05-07',
    endDate: '2019-05-13',
    description: 'Digital asset management application',
  },
  {
    id: '105',
    name: 'Windows Live Sync',
    logo: '🔄',
    launchDate: '2008-12-09',
    endDate: '2012-08-07',
    description: 'File and folder synchronization',
  },
  {
    id: '106',
    name: 'Google Fast Flip',
    logo: '📰',
    launchDate: '2009-09-08',
    endDate: '2011-09-01',
    description: 'Fast news browsing interface',
  },
  {
    id: '107',
    name: 'Microsoft Office InfoPath',
    logo: '📝',
    launchDate: '2003-08-19',
    endDate: '2016-07-14',
    description: 'Electronic forms designer',
  },
  {
    id: '108',
    name: 'Adobe Flex Builder',
    logo: '💪',
    launchDate: '2006-06-28',
    endDate: '2011-12-01',
    description: 'Rich Internet application development',
  },
  {
    id: '110',
    name: 'Google Website Optimizer',
    logo: '📊',
    launchDate: '2006-06-01',
    endDate: '2012-08-01',
    description: 'Website A/B testing service',
  },
  {
    id: '112',
    name: 'Adobe Soundbooth',
    logo: '🎵',
    launchDate: '2007-04-16',
    endDate: '2011-05-23',
    description: 'Audio editing software',
  },
  {
    id: '114',
    name: 'Google Dodgeball',
    logo: '⚽',
    launchDate: '2005-05-11',
    endDate: '2009-01-01',
    description: 'Location-based social networking',
  },
  {
    id: '115',
    name: 'Microsoft Expression Encoder',
    logo: '🎬',
    launchDate: '2007-08-01',
    endDate: '2013-11-07',
    description: 'Professional video encoding',
  },
  {
    id: '116',
    name: 'Adobe ExtendScript Toolkit',
    logo: '🔧',
    launchDate: '2005-04-01',
    endDate: '2020-07-01',
    description: 'Scripting environment for Creative Suite',
  },
  {
    id: '118',
    name: 'Google Gears',
    logo: '⚙️',
    launchDate: '2007-05-30',
    endDate: '2011-12-01',
    description: 'Offline web application support',
  },
  {
    id: '120',
    name: 'Adobe OnLocation',
    logo: '📍',
    launchDate: '2007-04-16',
    endDate: '2012-05-07',
    description: 'Direct-to-disk recording software',
  },
  {
    id: '122',
    name: 'Google Aardvark',
    logo: '🐾',
    launchDate: '2007-12-01',
    endDate: '2011-09-30',
    description: 'Social search service',
  },
  {
    id: '123',
    name: 'Microsoft Office Live',
    logo: '🌐',
    launchDate: '2005-11-01',
    endDate: '2012-04-30',
    description: 'Web-based business services',
  },
  {
    id: '126',
    name: 'Google Friend Connect',
    logo: '👥',
    launchDate: '2008-12-04',
    endDate: '2012-03-01',
    description: 'Social features for websites',
  },
  {
    id: '127',
    name: 'Microsoft Office Communicator',
    logo: '💬',
    launchDate: '2005-10-01',
    endDate: '2013-07-30',
    description: 'Enterprise instant messaging',
  },
  {
    id: '134',
    name: 'Google PowerMeter',
    logo: '⚡',
    launchDate: '2009-02-10',
    endDate: '2011-09-16',
    description: 'Energy usage monitoring tool',
  },
  {
    id: '136',
    name: 'Adobe Edge Animate',
    logo: '💫',
    launchDate: '2012-08-21',
    endDate: '2015-11-30',
    description: 'Web animation authoring tool',
  },
  {
    id: '138',
    name: 'Google Social Graph API',
    logo: '🕸️',
    launchDate: '2008-02-01',
    endDate: '2012-04-20',
    description: 'Social network relationship mapping',
  },
  {
    id: '139',
    name: 'Microsoft Office Live Meeting',
    logo: '🤝',
    launchDate: '2005-08-01',
    endDate: '2015-06-01',
    description: 'Web conferencing service',
  },
  {
    id: '140',
    name: 'Adobe Edge Code',
    logo: '💻',
    launchDate: '2012-09-17',
    endDate: '2014-12-01',
    description: 'Modern code editor for web development',
  },
  {
    id: '141',
    name: 'Windows Live SkyDrive',
    logo: '☁️',
    launchDate: '2007-08-01',
    endDate: '2014-02-19',
    description: 'Cloud storage service',
  },
  {
    id: '142',
    name: 'Google iGoogle',
    logo: '🏠',
    launchDate: '2005-05-19',
    endDate: '2013-11-01',
    description: 'Personalized homepage service',
  },
  {
    id: '143',
    name: 'Microsoft Office Document Imaging',
    logo: '📄',
    launchDate: '2003-08-19',
    endDate: '2010-04-15',
    description: 'Document scanning and OCR tool',
  },
  {
    id: '145',
    name: 'Windows Live Expo',
    logo: '🛍️',
    launchDate: '2006-05-01',
    endDate: '2010-07-31',
    description: 'Online classified advertising',
  },
  {
    id: '146',
    name: 'Google Sets',
    logo: '📋',
    launchDate: '2002-04-01',
    endDate: '2011-09-05',
    description: 'Automatic list completion service',
  },
  {
    id: '148',
    name: 'Adobe Edge Web Fonts',
    logo: '🔤',
    launchDate: '2012-10-03',
    endDate: '2018-07-01',
    description: 'Web font service',
  },
  {
    id: '149',
    name: 'Windows Live Academic',
    logo: '🎓',
    launchDate: '2006-04-11',
    endDate: '2011-05-21',
    description: 'Academic search engine',
  },
  {
    id: '150',
    name: 'Google Correlate',
    logo: '📈',
    launchDate: '2011-05-13',
    endDate: '2019-12-15',
    description: 'Data correlation analysis tool',
  },

  {
    id: '151',
    name: 'Plant Library',
    logo: '🪴',
    image: plantLibrary,
    launchDate: '2017-12-15',
    endDate: '2025-12-20',
    description: 'Huskvarna software',
  },
  {
    id: '152',
    name: 'Windows Phone 7',
    logo: '📱',
    launchDate: '2010-10-21',
    endDate: '2014-10-14',
    description: "Microsoft's mobile OS with Metro design",
  },
  {
    id: '156',
    name: 'Netscape Navigator',
    logo: '🧭',
    launchDate: '1994-12-15',
    endDate: '2008-02-01',
    description: 'Browser that pioneered the web',
  },
  {
    id: '157',
    name: 'AIM Express',
    logo: '💭',
    launchDate: '2006-05-16',
    endDate: '2010-03-03',
    description: 'Web-based instant messaging',
  },
  {
    id: '158',
    name: 'Microsoft Encarta',
    logo: '📚',
    launchDate: '1993-03-01',
    endDate: '2009-10-31',
    description: 'Digital multimedia encyclopedia',
  },
  {
    id: '159',
    name: 'Palm OS',
    logo: '🌴',
    launchDate: '1996-03-10',
    endDate: '2011-02-09',
    description: 'Pioneer of mobile computing',
  },
  {
    id: '160',
    name: 'RealPlayer',
    logo: '▶️',
    launchDate: '1995-04-01',
    endDate: '2016-08-18',
    description: 'Media player for streaming audio and video',
  },
  {
    id: '164',
    name: 'Windows Media Center',
    logo: '📺',
    launchDate: '2002-10-22',
    endDate: '2015-07-29',
    description: 'Home entertainment hub',
  },
  {
    id: '165',
    name: 'Picasa',
    logo: '📷',
    launchDate: '2002-07-13',
    endDate: '2016-03-15',
    description: 'Photo organization and editing software',
  },
  {
    id: '171',
    name: 'ICQ',
    logo: '🌼',
    launchDate: '1996-11-15',
    endDate: '2020-06-26',
    description: 'First mainstream instant messenger',
  },
  {
    id: '174',
    name: 'Microsoft Clippy',
    logo: '📎',
    launchDate: '1997-03-31',
    endDate: '2007-04-27',
    description: 'Infamous Office assistant',
  },
  {
    id: '175',
    name: 'Mozilla Firefox OS',
    logo: '🦊',
    launchDate: '2013-02-21',
    endDate: '2016-09-27',
    description: 'Web-based mobile operating system',
  },
  {
    id: '178',
    name: 'Windows 7',
    logo: '🖥️',
    launchDate: '2009-10-22',
    endDate: '2020-01-14',
    description: 'Beloved Windows operating system',
  },
  {
    id: '180',
    name: 'Delicious',
    logo: '🔖',
    launchDate: '2003-09-09',
    endDate: '2017-06-15',
    description: 'Social bookmarking service',
  },
  {
    id: '183',
    name: 'QuickTime Player',
    logo: '⏯️',
    launchDate: '1991-12-02',
    endDate: '2016-04-14',
    description: "Apple's multimedia framework",
  },
  {
    id: '184',
    name: 'Google Notebook',
    logo: '📓',
    launchDate: '2006-05-10',
    endDate: '2012-07-17',
    description: 'Online note-taking application',
  },
  {
    id: '186',
    name: 'Adobe Muse',
    logo: '🎨',
    launchDate: '2012-08-20',
    endDate: '2020-03-26',
    description: 'Website design without coding',
  },
  {
    id: '187',
    name: 'Windows Phone 8',
    logo: '📲',
    launchDate: '2012-10-29',
    endDate: '2017-07-11',
    description: "Microsoft's mobile platform evolution",
  },
  {
    id: '189',
    name: 'Microsoft Groove',
    logo: '🎶',
    launchDate: '2015-07-07',
    endDate: '2017-12-31',
    description: 'Music streaming service',
  },
  {
    id: '190',
    name: 'Windows Live Hotmail',
    logo: '📧',
    launchDate: '1996-07-04',
    endDate: '2013-05-02',
    description: 'Free web-based email service',
  },
  {
    id: '192',
    name: 'Google Labs',
    logo: '🧪',
    launchDate: '2002-06-01',
    endDate: '2011-07-20',
    description: 'Experimental Google features',
  },
  {
    id: '194',
    name: 'Windows Media Player',
    logo: '🎵',
    launchDate: '1991-10-01',
    endDate: '2019-05-10',
    description: 'Classic multimedia player',
  },
  {
    id: '195',
    name: 'Google Latitude',
    logo: '📍',
    launchDate: '2009-02-04',
    endDate: '2013-08-09',
    description: 'Location sharing service',
  },
  {
    id: '197',
    name: 'Adobe EdgeHTML',
    logo: '🌐',
    launchDate: '2015-07-29',
    endDate: '2020-01-15',
    description: 'Microsoft Edge browser engine',
  },
  {
    id: '198',
    name: 'Google Goggles',
    logo: '🥽',
    launchDate: '2009-12-07',
    endDate: '2018-08-20',
    description: 'Visual search application',
  },
  {
    id: '199',
    name: 'Microsoft Zune',
    logo: '🎧',
    launchDate: '2006-11-14',
    endDate: '2012-10-03',
    description: 'Portable media player',
  },
  {
    id: '201',
    name: 'Google Talk',
    logo: '💬',
    launchDate: '2005-08-24',
    endDate: '2017-06-26',
    description: 'Instant messaging service',
  },
  {
    id: '202',
    name: 'Adobe ColdFusion Builder',
    logo: '🧊',
    launchDate: '2010-03-22',
    endDate: '2021-03-11',
    description: 'IDE for ColdFusion development',
  },
  {
    id: '205',
    name: 'Microsoft Silverlight',
    logo: '🌙',
    launchDate: '2007-09-05',
    endDate: '2021-10-12',
    description: 'Web application framework',
  },
  {
    id: '208',
    name: 'Adobe Contribute',
    logo: '✏️',
    launchDate: '2002-09-23',
    endDate: '2017-01-31',
    description: 'Website content management',
  },
  {
    id: '211',
    name: 'Microsoft Bob',
    logo: '🐕',
    launchDate: '1995-03-11',
    endDate: '1996-08-15',
    description: 'Friendly user interface software',
  },
  {
    id: '213',
    name: 'Google Checkout',
    logo: '💳',
    launchDate: '2006-06-29',
    endDate: '2013-11-20',
    description: 'Online payment service',
  },
  {
    id: '214',
    name: 'Adobe AIR',
    logo: '🌬️',
    launchDate: '2008-02-25',
    endDate: '2023-01-12',
    description: 'Cross-platform runtime system',
  },
  {
    id: '215',
    name: 'Windows Live Family Safety',
    logo: '👨‍👩‍👧‍👦',
    launchDate: '2007-11-06',
    endDate: '2012-09-18',
    description: 'Parental control software',
  },
  {
    id: '216',
    name: 'Google Helpouts',
    logo: '🤝',
    launchDate: '2013-11-05',
    endDate: '2015-04-20',
    description: 'Live video help platform',
  },
  {
    id: '218',
    name: 'Windows Live Contacts',
    logo: '📇',
    launchDate: '2005-11-01',
    endDate: '2013-02-13',
    description: 'Contact management service',
  },
  {
    id: '219',
    name: 'Google Answers',
    logo: '❔',
    launchDate: '2002-04-09',
    endDate: '2006-11-28',
    description: 'Q&A marketplace',
  },
  {
    id: '220',
    name: 'Adobe Device Central',
    logo: '📱',
    launchDate: '2007-04-16',
    endDate: '2013-06-17',
    description: 'Mobile device testing',
  },
  {
    id: '221',
    name: 'Windows Journal',
    logo: '📖',
    launchDate: '2002-11-07',
    endDate: '2016-08-12',
    description: 'Note-taking application',
  },
  {
    id: '222',
    name: 'Google Code Search',
    logo: '🔍',
    launchDate: '2006-10-05',
    endDate: '2013-01-15',
    description: 'Source code search engine',
  },
  {
    id: '223',
    name: 'Microsoft Works',
    logo: '🛠️',
    launchDate: '1987-09-01',
    endDate: '2010-10-08',
    description: 'Productivity software suite',
  },
  {
    id: '224',
    name: 'Windows Live Favorites',
    logo: '⭐',
    launchDate: '2008-03-04',
    endDate: '2011-08-24',
    description: 'Online bookmarking service',
  },
  {
    id: '225',
    name: 'Google Pack',
    logo: '📦',
    launchDate: '2006-01-06',
    endDate: '2011-09-06',
    description: 'Software bundle',
  },
  {
    id: '227',
    name: 'Windows Anytime Upgrade',
    logo: '⬆️',
    launchDate: '2009-10-22',
    endDate: '2015-07-29',
    description: 'Windows edition upgrade tool',
  },
  {
    id: '228',
    name: 'Google Moderator',
    logo: '🗳️',
    launchDate: '2008-09-25',
    endDate: '2015-07-31',
    description: 'Question ranking service',
  },
  {
    id: '229',
    name: 'Microsoft PhotoDraw',
    logo: '🖼️',
    launchDate: '1999-12-01',
    endDate: '2004-03-14',
    description: 'Graphics editing software',
  },
  {
    id: '231',
    name: 'Google Building Maker',
    logo: '🏢',
    launchDate: '2009-10-12',
    endDate: '2013-06-04',
    description: '3D building modeling',
  },
  {
    id: '232',
    name: 'Adobe Photoshop Touch',
    logo: '🎨',
    launchDate: '2012-02-01',
    endDate: '2015-05-28',
    description: 'Mobile photo editing',
  },
  {
    id: '234',
    name: 'Google Refine',
    logo: '🔬',
    launchDate: '2010-11-10',
    endDate: '2012-10-02',
    description: 'Data cleaning tool',
  },
  {
    id: '235',
    name: 'Microsoft FrontPage',
    logo: '🌐',
    launchDate: '1995-11-06',
    endDate: '2006-12-31',
    description: 'WYSIWYG HTML editor',
  },
  {
    id: '237',
    name: 'Google Questions and Answers',
    logo: '💭',
    launchDate: '2007-12-13',
    endDate: '2011-12-06',
    description: 'Local Q&A service',
  },
  {
    id: '239',
    name: 'Windows CardSpace',
    logo: '🎴',
    launchDate: '2006-11-21',
    endDate: '2011-02-15',
    description: 'Digital identity management',
  },
  {
    id: '240',
    name: 'Google Dodgeball',
    logo: '⚽',
    launchDate: '2005-05-11',
    endDate: '2009-02-16',
    description: 'Location-based social network',
  },
  {
    id: '242',
    name: 'Windows Live Toolbar',
    logo: '🔧',
    launchDate: '2005-11-01',
    endDate: '2012-05-29',
    description: 'Browser toolbar',
  },
  {
    id: '244',
    name: 'Adobe Edge Reflow',
    logo: '📐',
    launchDate: '2013-05-06',
    endDate: '2016-03-01',
    description: 'Responsive web design tool',
  },
  {
    id: '245',
    name: 'Windows Defender Offline',
    logo: '🛡️',
    launchDate: '2011-03-15',
    endDate: '2017-09-26',
    description: 'Offline malware scanner',
  },
  {
    id: '246',
    name: 'Google Shopper',
    logo: '🛒',
    launchDate: '2010-12-16',
    endDate: '2013-08-30',
    description: 'Shopping comparison app',
  },
  {
    id: '247',
    name: 'Microsoft Popfly',
    logo: '🦋',
    launchDate: '2007-05-04',
    endDate: '2009-08-24',
    description: 'Mashup creator',
  },
  {
    id: '249',
    name: 'Google Talk Labs Edition',
    logo: '🧑‍🔬',
    launchDate: '2007-11-26',
    endDate: '2011-11-16',
    description: 'Experimental chat client',
  },
  {
    id: '250',
    name: 'Adobe Extension Manager',
    logo: '🧩',
    launchDate: '2004-09-01',
    endDate: '2017-06-13',
    description: 'Plugin management tool',
  },
  {
    id: '252',
    name: 'Google Audio Ads',
    logo: '🔊',
    launchDate: '2007-04-01',
    endDate: '2009-02-12',
    description: 'Radio advertising service',
  },
  {
    id: '253',
    name: 'Microsoft Kin',
    logo: '📱',
    launchDate: '2010-05-13',
    endDate: '2010-06-30',
    description: 'Social media phone',
  },
  {
    id: '254',
    name: 'Windows Live Events',
    logo: '🎊',
    launchDate: '2008-09-15',
    endDate: '2011-11-20',
    description: 'Event planning service',
  },
  {
    id: '255',
    name: 'Google Page Creator',
    logo: '📄',
    launchDate: '2006-02-23',
    endDate: '2009-06-01',
    description: 'Web page creation tool',
  },
  {
    id: '256',
    name: 'Adobe Shadow',
    logo: '👤',
    launchDate: '2012-03-12',
    endDate: '2012-09-17',
    description: 'Mobile device testing',
  },
  {
    id: '257',
    name: 'Windows DreamScene',
    logo: '🖼️',
    launchDate: '2007-10-30',
    endDate: '2010-06-28',
    description: 'Animated desktop backgrounds',
  },
  {
    id: '258',
    name: 'Google Jaiku',
    logo: '🐦',
    launchDate: '2007-10-09',
    endDate: '2012-01-16',
    description: 'Microblogging service',
  },
  {
    id: '259',
    name: 'Microsoft Sync Framework',
    logo: '🔄',
    launchDate: '2007-11-29',
    endDate: '2015-05-18',
    description: 'Data synchronization',
  },
  {
    id: '260',
    name: 'Windows Live Alerts',
    logo: '🔔',
    launchDate: '2005-11-01',
    endDate: '2012-04-22',
    description: 'Notification service',
  },
  {
    id: '261',
    name: 'Google Web Accelerator',
    logo: '🚀',
    launchDate: '2005-05-04',
    endDate: '2008-01-23',
    description: 'Web browsing speedup',
  },
  {
    id: '262',
    name: 'Adobe Scout',
    logo: '🔭',
    launchDate: '2012-11-05',
    endDate: '2017-12-11',
    description: 'Performance profiling',
  },
  {
    id: '263',
    name: 'Windows DVD Maker',
    logo: '💿',
    launchDate: '2006-11-30',
    endDate: '2016-05-19',
    description: 'DVD authoring tool',
  },
  {
    id: '264',
    name: 'Google Print Ads',
    logo: '📰',
    launchDate: '2006-11-06',
    endDate: '2009-02-28',
    description: 'Newspaper advertising',
  },
  {
    id: '265',
    name: 'Microsoft Tag',
    logo: '🏷️',
    launchDate: '2009-01-08',
    endDate: '2015-08-19',
    description: '2D barcode service',
  },
  {
    id: '266',
    name: 'Windows Upgrade Advisor',
    logo: '💡',
    launchDate: '2009-05-05',
    endDate: '2016-07-27',
    description: 'System compatibility checker',
  },
  {
    id: '267',
    name: 'Google Catalogs',
    logo: '📖',
    launchDate: '2011-08-25',
    endDate: '2015-08-15',
    description: 'Shopping catalog browser',
  },
  {
    id: '268',
    name: 'Adobe BrowserLab',
    logo: '🧪',
    launchDate: '2010-03-18',
    endDate: '2013-03-13',
    description: 'Cross-browser testing',
  },
  {
    id: '269',
    name: 'Windows Home Server',
    logo: '🏡',
    launchDate: '2007-07-16',
    endDate: '2012-04-05',
    description: 'Home network server',
  },
  {
    id: '270',
    name: 'Google Lively',
    logo: '🎮',
    launchDate: '2008-07-08',
    endDate: '2008-11-19',
    description: 'Virtual world chat',
  },
  {
    id: '271',
    name: 'Microsoft InfoPath',
    logo: '📋',
    launchDate: '2003-11-17',
    endDate: '2023-04-11',
    description: 'Electronic forms software',
  },
  {
    id: '272',
    name: 'Windows Fax and Scan',
    logo: '📠',
    launchDate: '2006-11-30',
    endDate: '2019-11-12',
    description: 'Document faxing and scanning',
  },
  {
    id: '273',
    name: 'Google Schemer',
    logo: '💡',
    launchDate: '2011-12-07',
    endDate: '2014-02-07',
    description: 'Things to do sharing',
  },
  {
    id: '274',
    name: 'Adobe GameFace',
    logo: '🎭',
    launchDate: '2012-04-17',
    endDate: '2013-08-05',
    description: 'Social gaming platform',
  },
  {
    id: '275',
    name: 'Windows Live Groups',
    logo: '👥',
    launchDate: '2001-09-18',
    endDate: '2009-02-21',
    description: 'Online group collaboration',
  },
  {
    id: '276',
    name: 'Google Related',
    logo: '🔗',
    launchDate: '2011-09-19',
    endDate: '2012-12-18',
    description: 'Content recommendation',
  },
  {
    id: '277',
    name: 'Microsoft Student',
    logo: '🎓',
    launchDate: '2006-09-05',
    endDate: '2009-06-23',
    description: 'Educational software suite',
  },
  {
    id: '278',
    name: 'Windows Speech Recognition',
    logo: '🎤',
    launchDate: '2006-11-30',
    endDate: '2018-03-06',
    description: 'Voice control system',
  },
  {
    id: '279',
    name: 'Google Shared Spaces',
    logo: '🌐',
    launchDate: '2007-10-30',
    endDate: '2011-04-11',
    description: 'Real-time collaboration',
  },
  {
    id: '280',
    name: 'Adobe Proto',
    logo: '✏️',
    launchDate: '2011-10-03',
    endDate: '2014-07-14',
    description: 'Website wireframing',
  },
  {
    id: '281',
    name: 'Windows Recovery Environment',
    logo: '🔧',
    launchDate: '2006-11-08',
    endDate: '2021-06-24',
    description: 'System recovery tools',
  },
  {
    id: '282',
    name: 'Google One Pass',
    logo: '🎫',
    launchDate: '2011-02-16',
    endDate: '2012-12-03',
    description: 'Digital content payment',
  },
  {
    id: '283',
    name: 'Microsoft Expression Web',
    logo: '🌐',
    launchDate: '2006-12-19',
    endDate: '2012-12-20',
    description: 'Web design software',
  },
  {
    id: '284',
    name: 'Windows Contacts',
    logo: '📇',
    launchDate: '2006-11-30',
    endDate: '2017-05-11',
    description: 'Contact management',
  },
  {
    id: '287',
    name: 'Windows Mobility Center',
    logo: '💼',
    launchDate: '2006-11-30',
    endDate: '2020-08-17',
    description: 'Mobile PC settings',
  },
  {
    id: '288',
    name: 'Google Flu Trends',
    logo: '🤒',
    launchDate: '2008-11-11',
    endDate: '2015-08-20',
    description: 'Disease surveillance',
  },
  {
    id: '289',
    name: 'Microsoft Expression Blend',
    logo: '🎨',
    launchDate: '2007-08-01',
    endDate: '2012-08-13',
    description: 'UI design tool',
  },
  {
    id: '290',
    name: 'Windows Collaboration',
    logo: '🤝',
    launchDate: '2007-01-30',
    endDate: '2012-10-26',
    description: 'Meeting and sharing',
  },
  {
    id: '292',
    name: 'Adobe Digital Publishing Suite',
    logo: '📱',
    launchDate: '2010-08-10',
    endDate: '2019-08-30',
    description: 'Digital magazine publishing',
  },
  {
    id: '293',
    name: 'Windows BitLocker To Go',
    logo: '🔐',
    launchDate: '2009-10-22',
    endDate: '2021-10-05',
    description: 'USB drive encryption',
  },
  {
    id: '294',
    name: 'Google Slide',
    logo: '🖼️',
    launchDate: '2007-08-21',
    endDate: '2012-09-11',
    description: 'Image search widget',
  },
  {
    id: '295',
    name: 'Microsoft Office Accounting',
    logo: '💼',
    launchDate: '2006-10-03',
    endDate: '2009-11-14',
    description: 'Small business accounting',
  },
  {
    id: '296',
    name: 'Windows Troubleshooting',
    logo: '🔍',
    launchDate: '2009-10-22',
    endDate: '2021-07-22',
    description: 'Automated problem solving',
  },
  {
    id: '298',
    name: 'Adobe Digital Editions',
    logo: '📚',
    launchDate: '2006-09-19',
    endDate: '2022-11-08',
    description: 'E-book reader',
  },
  {
    id: '299',
    name: 'Windows Action Center',
    logo: '🎯',
    launchDate: '2009-10-22',
    endDate: '2020-09-03',
    description: 'System notifications hub',
  },
  {
    id: '300',
    name: 'Google Chrome Frame',
    logo: '🖼️',
    launchDate: '2009-09-22',
    endDate: '2014-02-25',
    description: 'IE plugin for Chrome',
  },
  {
    id: '301',
    name: 'Microsoft Bing Bar',
    logo: '🔎',
    launchDate: '2009-06-03',
    endDate: '2016-03-31',
    description: 'Browser toolbar',
  },
  {
    id: '302',
    name: 'Windows ReadyBoost',
    logo: '⚡',
    launchDate: '2006-11-30',
    endDate: '2020-10-20',
    description: 'USB drive performance boost',
  },
  {
    id: '303',
    name: 'Google Dashboard',
    logo: '📊',
    launchDate: '2009-11-05',
    endDate: '2018-06-18',
    description: 'Account data overview',
  },
  {
    id: '304',
    name: 'Adobe Connect Now',
    logo: '🎥',
    launchDate: '2007-06-25',
    endDate: '2010-09-27',
    description: 'Web conferencing',
  },
  {
    id: '305',
    name: 'Windows Backup',
    logo: '💾',
    launchDate: '1995-08-24',
    endDate: '2020-05-27',
    description: 'System backup utility',
  },
  {
    id: '306',
    name: 'Google Desktop Gadgets',
    logo: '⚙️',
    launchDate: '2005-04-14',
    endDate: '2012-07-03',
    description: 'Desktop widgets',
  },
  {
    id: '307',
    name: 'Microsoft Photosynth',
    logo: '📷',
    launchDate: '2008-08-20',
    endDate: '2017-02-06',
    description: '3D photo stitching',
  },
  {
    id: '308',
    name: 'Windows Remote Assistance',
    logo: '🆘',
    launchDate: '2001-10-25',
    endDate: '2021-09-29',
    description: 'Remote help tool',
  },
  {
    id: '309',
    name: 'Google Bookmarks',
    logo: '🔖',
    launchDate: '2005-10-10',
    endDate: '2021-09-30',
    description: 'Web bookmarking',
  },
  {
    id: '310',
    name: 'Adobe Edge Code',
    logo: '💻',
    launchDate: '2012-06-11',
    endDate: '2014-11-17',
    description: 'Web code editor',
  },
  {
    id: '311',
    name: 'Windows Sync Center',
    logo: '🔄',
    launchDate: '2006-11-30',
    endDate: '2021-11-25',
    description: 'File synchronization',
  },
  {
    id: '312',
    name: 'Google TV Ads',
    logo: '📺',
    launchDate: '2007-05-23',
    endDate: '2012-08-30',
    description: 'Television advertising',
  },
  {
    id: '313',
    name: 'Microsoft Live Labs Pivot',
    logo: '🔄',
    launchDate: '2010-02-15',
    endDate: '2014-06-06',
    description: 'Data visualization',
  },
  {
    id: '314',
    name: 'Windows Problem Steps Recorder',
    logo: '🎬',
    launchDate: '2009-10-22',
    endDate: '2022-02-08',
    description: 'Screen recording for troubleshooting',
  },
  {
    id: '315',
    name: 'Google Offers',
    logo: '🎁',
    launchDate: '2011-06-02',
    endDate: '2014-09-23',
    description: 'Deal aggregator',
  },
  {
    id: '316',
    name: 'Adobe FormsCentral',
    logo: '📝',
    launchDate: '2012-04-23',
    endDate: '2015-07-28',
    description: 'Online form builder',
  },
  {
    id: '317',
    name: 'Windows Experience Index',
    logo: '📈',
    launchDate: '2006-11-30',
    endDate: '2015-07-15',
    description: 'Performance rating',
  },
  {
    id: '318',
    name: 'Google Code Jam',
    logo: '🏆',
    launchDate: '2003-09-27',
    endDate: '2023-03-19',
    description: 'Programming competition',
  },
  {
    id: '319',
    name: 'Microsoft Songsmith',
    logo: '🎼',
    launchDate: '2009-01-29',
    endDate: '2011-12-22',
    description: 'Music composition',
  },
  {
    id: '320',
    name: 'Windows Parental Controls',
    logo: '👶',
    launchDate: '2006-11-30',
    endDate: '2020-12-09',
    description: 'Child safety features',
  },
  {
    id: '321',
    name: 'Google Fast Search Transfer',
    logo: '🚀',
    launchDate: '2008-03-17',
    endDate: '2010-09-01',
    description: 'File transfer utility',
  },
  {
    id: '322',
    name: 'Adobe MediaServer',
    logo: '📡',
    launchDate: '2002-07-01',
    endDate: '2023-09-12',
    description: 'Streaming media server',
  },
  {
    id: '323',
    name: 'Windows Easy Transfer',
    logo: '📦',
    launchDate: '2006-11-30',
    endDate: '2016-07-29',
    description: 'File migration tool',
  },
  {
    id: '324',
    name: 'Google SendToPhone',
    logo: '📱',
    launchDate: '2010-08-11',
    endDate: '2013-05-25',
    description: 'Content sharing',
  },
  {
    id: '325',
    name: 'Microsoft Hohm',
    logo: '⚡',
    launchDate: '2009-06-24',
    endDate: '2012-05-31',
    description: 'Energy efficiency',
  },
  {
    id: '326',
    name: 'Windows Network Projection',
    logo: '📽️',
    launchDate: '2009-10-22',
    endDate: '2022-01-18',
    description: 'Wireless display',
  },
  {
    id: '327',
    name: 'Google Maps Navigation',
    logo: '🧭',
    launchDate: '2009-10-28',
    endDate: '2020-03-04',
    description: 'Turn-by-turn directions',
  },
  {
    id: '328',
    name: 'Adobe Encore',
    logo: '💿',
    launchDate: '2003-09-01',
    endDate: '2021-06-16',
    description: 'DVD authoring',
  },
  {
    id: '329',
    name: 'Windows System Assessment Tool',
    logo: '🔬',
    launchDate: '2006-11-30',
    endDate: '2021-04-13',
    description: 'Performance measurement',
  },
  {
    id: '330',
    name: 'Google Sparrow',
    logo: '🐦',
    launchDate: '2011-02-09',
    endDate: '2013-07-20',
    description: 'Email client',
  },
  {
    id: '331',
    name: 'Microsoft Vine',
    logo: '🎬',
    launchDate: '2008-06-17',
    endDate: '2011-10-04',
    description: 'Video annotation',
  },
  {
    id: '332',
    name: 'Windows Performance Monitor',
    logo: '📊',
    launchDate: '1993-07-27',
    endDate: '2021-08-10',
    description: 'System performance tracking',
  },
  {
    id: '333',
    name: 'Google Body Browser',
    logo: '🫀',
    launchDate: '2010-12-15',
    endDate: '2012-06-01',
    description: '3D human anatomy',
  },
  {
    id: '334',
    name: 'Adobe Carousel',
    logo: '🎠',
    launchDate: '2011-10-03',
    endDate: '2014-03-31',
    description: 'Photo management',
  },
  {
    id: '335',
    name: 'Windows Snipping Tool',
    logo: '✂️',
    launchDate: '2006-11-30',
    endDate: '2021-10-04',
    description: 'Screenshot utility',
  },
  {
    id: '337',
    name: 'Microsoft Max',
    logo: '🖼️',
    launchDate: '2006-09-01',
    endDate: '2008-07-18',
    description: 'Photo sharing',
  },
  {
    id: '338',
    name: 'Windows Defender',
    logo: '🛡️',
    launchDate: '2006-10-24',
    endDate: '2020-12-21',
    description: 'Antispyware protection',
  },
  {
    id: '339',
    name: 'Google Image Swirl',
    logo: '🌀',
    launchDate: '2009-11-17',
    endDate: '2011-07-27',
    description: 'Image clustering',
  },
  {
    id: '340',
    name: 'Adobe Ideas',
    logo: '💡',
    launchDate: '2010-06-07',
    endDate: '2016-01-29',
    description: 'Vector drawing app',
  },
  {
    id: '341',
    name: 'Windows Reliability Monitor',
    logo: '📉',
    launchDate: '2006-11-30',
    endDate: '2022-03-14',
    description: 'System stability tracking',
  },
  {
    id: '342',
    name: 'Google Accessible Search',
    logo: '♿',
    launchDate: '2004-04-07',
    endDate: '2014-09-10',
    description: 'Accessibility focused search',
  },
  {
    id: '343',
    name: 'Microsoft Acrylic',
    logo: '🎨',
    launchDate: '2005-01-11',
    endDate: '2007-08-01',
    description: 'Graphic design software',
  },
  {
    id: '344',
    name: 'Windows Resource Monitor',
    logo: '⚙️',
    launchDate: '2006-11-30',
    endDate: '2022-05-17',
    description: 'Real-time resource usage',
  },
  {
    id: '345',
    name: 'Google Slide Show',
    logo: '🎞️',
    launchDate: '2006-08-22',
    endDate: '2011-10-18',
    description: 'Photo slideshow maker',
  },
  {
    id: '346',
    name: 'Adobe Nav',
    logo: '🧭',
    launchDate: '2011-05-09',
    endDate: '2013-12-04',
    description: 'Photoshop remote control',
  },
  {
    id: '347',
    name: 'Windows Task Scheduler',
    logo: '⏰',
    launchDate: '1995-08-24',
    endDate: '2022-06-21',
    description: 'Automated task management',
  },
  {
    id: '348',
    name: 'Google Reader Play',
    logo: '▶️',
    launchDate: '2010-06-22',
    endDate: '2011-11-01',
    description: 'Feed content browser',
  },
  {
    id: '350',
    name: 'Windows BitLocker',
    logo: '🔐',
    launchDate: '2006-11-30',
    endDate: '2023-07-25',
    description: 'Full disk encryption',
  },
  {
    id: '351',
    name: 'Google Gears',
    logo: '⚙️',
    launchDate: '2007-05-31',
    endDate: '2011-03-11',
    description: 'Offline web applications',
  },
  {
    id: '352',
    name: 'Adobe Color Lava',
    logo: '🌈',
    launchDate: '2011-10-03',
    endDate: '2013-05-15',
    description: 'Color theme exploration',
  },
  {
    id: '353',
    name: 'Windows SuperFetch',
    logo: '⚡',
    launchDate: '2006-11-30',
    endDate: '2023-08-29',
    description: 'Memory optimization',
  },
  {
    id: '355',
    name: 'Microsoft Tinker',
    logo: '🎮',
    launchDate: '2008-09-23',
    endDate: '2011-06-07',
    description: 'Puzzle game',
  },
  {
    id: '356',
    name: 'Windows ReadyDrive',
    logo: '💿',
    launchDate: '2006-11-30',
    endDate: '2023-09-26',
    description: 'Hybrid drive support',
  },
  {
    id: '357',
    name: 'Google SearchWiki',
    logo: '📝',
    launchDate: '2008-11-20',
    endDate: '2010-09-03',
    description: 'Customizable search results',
  },
  {
    id: '358',
    name: 'Adobe Revel',
    logo: '📸',
    launchDate: '2012-03-01',
    endDate: '2016-09-15',
    description: 'Cloud photo service',
  },
  {
    id: '359',
    name: 'Windows Remote Desktop',
    logo: '🖥️',
    launchDate: '1998-06-25',
    endDate: '2023-10-10',
    description: 'Remote computer access',
  },
  {
    id: '360',
    name: 'Google Nexus One',
    logo: '📱',
    launchDate: '2010-01-05',
    endDate: '2011-07-06',
    description: "Google's flagship phone",
  },
  {
    id: '361',
    name: 'Microsoft Streets & Trips',
    logo: '🗺️',
    launchDate: '1994-01-01',
    endDate: '2014-12-31',
    description: 'Mapping and route planning',
  },
  {
    id: '362',
    name: 'Windows Security Essentials',
    logo: '🔒',
    launchDate: '2009-09-29',
    endDate: '2023-11-14',
    description: 'Antivirus software',
  },
  {
    id: '363',
    name: 'Google Wallet Card',
    logo: '💳',
    launchDate: '2013-11-20',
    endDate: '2016-06-30',
    description: 'Physical payment card',
  },
  {
    id: '364',
    name: 'Adobe Debut',
    logo: '🎬',
    launchDate: '2011-05-09',
    endDate: '2012-11-05',
    description: 'Screen sharing',
  },
  {
    id: '365',
    name: 'Windows Distributed File System',
    logo: '📁',
    launchDate: '1998-12-01',
    endDate: '2023-12-26',
    description: 'Network file sharing',
  },
  {
    id: '368',
    name: 'StumbleUpon',
    logo: '🎲',
    launchDate: '2002-11-01',
    endDate: '2018-06-30',
    description: 'Web discovery and rating platform',
  },
  {
    id: '370',
    name: 'Mozilla Thunderbird 2.0',
    logo: '⚡',
    launchDate: '2007-04-19',
    endDate: '2010-03-24',
    description: 'Email client version',
  },
  {
    id: '374',
    name: 'Pebble Smartwatch',
    logo: '⌚',
    launchDate: '2013-01-23',
    endDate: '2016-12-07',
    description: 'Early smartwatch platform',
  },
  {
    id: '376',
    name: 'Megaupload',
    logo: '📦',
    launchDate: '2005-03-21',
    endDate: '2012-01-19',
    description: 'File hosting service',
  },
  {
    id: '377',
    name: 'Rapidshare',
    logo: '⚡',
    launchDate: '2002-01-01',
    endDate: '2015-03-31',
    description: 'File hosting and sharing service',
  },
  {
    id: '379',
    name: 'Windows Live Messenger',
    logo: '💬',
    launchDate: '2005-12-13',
    endDate: '2014-10-31',
    description: 'Instant messaging successor to MSN Messenger',
  },
  {
    id: '381',
    name: 'Netscape Communicator',
    logo: '📡',
    launchDate: '1997-06-01',
    endDate: '2006-02-01',
    description: 'Internet suite browser',
  },
  {
    id: '382',
    name: 'Opera Mini 4',
    logo: '🎭',
    launchDate: '2007-10-30',
    endDate: '2015-11-08',
    description: 'Mobile web browser',
  },
  {
    id: '383',
    name: 'Firefox 3.6',
    logo: '🦊',
    launchDate: '2010-01-21',
    endDate: '2012-04-24',
    description: 'Popular Firefox version',
  },
  {
    id: '387',
    name: 'Digg v4',
    logo: '⬆️',
    launchDate: '2010-08-25',
    endDate: '2012-07-12',
    description: 'Social news aggregation',
  },
  {
    id: '388',
    name: 'TechCrunch Redesign 2011',
    logo: '📱',
    launchDate: '2011-06-20',
    endDate: '2013-09-08',
    description: 'Tech news website version',
  },
  {
    id: '393',
    name: 'Adobe Atmosphere',
    logo: '🌍',
    launchDate: '2001-02-01',
    endDate: '2004-12-08',
    description: '3D web platform',
  },
  {
    id: '394',
    name: 'Microsoft Bob',
    logo: '👨',
    launchDate: '1995-03-11',
    endDate: '1996-04-20',
    description: 'User-friendly interface software',
  },
  {
    id: '395',
    name: 'Netscape Navigator 9',
    logo: '⛵',
    launchDate: '2007-10-15',
    endDate: '2008-02-20',
    description: 'Final version of classic browser',
  },
  {
    id: '396',
    name: 'Adobe ImageReady',
    logo: '🖼️',
    launchDate: '1998-05-01',
    endDate: '2007-10-15',
    description: 'Web graphics editor',
  },
  {
    id: '398',
    name: 'Flip Video Camera',
    logo: '📹',
    launchDate: '2007-05-15',
    endDate: '2011-04-12',
    description: 'Portable video camera',
  },
  {
    id: '400',
    name: 'Altavista',
    logo: '🔎',
    launchDate: '1995-12-15',
    endDate: '2013-07-08',
    description: 'Early web search engine',
  },
  // --- BEGIN: Generated placeholder entries for missing MM-DDs ---
  {
    id: '99901',
    name: 'Office Assistant',
    logo: '🌐',
    launchDate: '1996-01-01',
    endDate: '2007-01-01',
    description: 'Office Assistant was an intelligent user interface for Microsoft Office that ...',
  },
  {
    id: '99902',
    name: 'Visual J++',
    logo: '📱',
    launchDate: '1996-12-01',
    endDate: '2004-01-02',
    description: "Visual J++ (pronounced 'Jay Plus Plus') was a Microsoft's implementation of J...",
  },
  {
    id: '99903',
    name: 'Google Shopper',
    logo: '🛒',
    launchDate: '2010-12-16',
    endDate: '2013-01-03',
    description: 'Mobile shopping comparison app',
  },
  {
    id: '99904',
    name: 'Windows Live Spaces',
    logo: '🌐',
    launchDate: '2004-12-01',
    endDate: '2011-01-04',
    description: 'Windows Live Spaces (previously MSN Spaces) was a highly customizable bloggin...',
  },
  {
    id: '99905',
    name: 'Android Things',
    logo: '🌐',
    launchDate: '2015-05-28',
    endDate: '2022-01-05',
    description: 'Android Things was an Android-based embedded operating system (originally nam...',
  },
  {
    id: '99906',
    name: 'Google Pack',
    logo: '📦',
    launchDate: '2006-01-06',
    endDate: '2011-01-06',
    description: 'Free software bundle by Google',
  },
  {
    id: '99907',
    name: 'Windows Home Server 2011',
    logo: '🏠',
    launchDate: '2011-04-06',
    endDate: '2016-01-07',
    description: 'Home server operating system',
  },
  {
    id: '99908',
    name: 'Microsoft Office PerformancePoint Server',
    logo: '📱',
    launchDate: '2007-12-20',
    endDate: '2013-01-08',
    description: 'Microsoft Office PerformancePoint Server was a business intelligence software...',
  },
  {
    id: '99909',
    name: 'Microsoft Lens',
    logo: '📱',
    launchDate: '2014-03-17',
    endDate: '2026-01-09',
    description: 'Microsoft Lens (formerly Microsoft Office Lens) was a OneNote companion app d...',
  },
  {
    id: '99910',
    name: 'Windows Live Mail',
    logo: '📱',
    launchDate: '2007-11-06',
    endDate: '2017-01-10',
    description: 'Windows Live Mail (formerly named Windows Live Mail Desktop) was a freeware e...',
  },
  {
    id: '99911',
    name: 'Google OnHub',
    logo: '🔧',
    launchDate: '2015-08-31',
    endDate: '2023-01-11',
    description: 'Google OnHub was a series of residential wireless routers manufactured by Asu...',
  },
  {
    id: '99912',
    name: 'Visual FoxPro',
    logo: '📱',
    launchDate: '1995-06-01',
    endDate: '2010-01-12',
    description: 'Visual FoxPro was data-centric procedural programming language with object-or...',
  },
  {
    id: '99913',
    name: 'Adobe Contribute 6.5',
    logo: '✏️',
    launchDate: '2012-06-11',
    endDate: '2015-01-13',
    description: 'Web content management tool',
  },
  {
    id: '99914',
    name: 'Word Lens',
    logo: '📱',
    launchDate: '2010-12-06',
    endDate: '2015-01-14',
    description: 'Word Lens translated text in real time on images by using the viewfinder of a...',
  },
  {
    id: '99915',
    name: 'YouTube Video Annotations',
    logo: '🌐',
    launchDate: '2008-06-04',
    endDate: '2019-01-15',
    description: 'YouTube Video Annotations allowed video creators to add interactive commentar...',
  },
  {
    id: '99916',
    name: 'Active Server Pages (ASP)',
    logo: '📱',
    launchDate: '1996-12-01',
    endDate: '2002-01-16',
    description: "Active Server Pages (ASP) was the Microsoft's first server-side scripting lan...",
  },
  {
    id: '99917',
    name: 'Windows Movie Maker',
    logo: '📱',
    launchDate: '2000-09-14',
    endDate: '2017-01-17',
    description: 'Windows Movie Maker (later rebranded as Windows Live Movie Maker) was a video...',
  },
  {
    id: '99918',
    name: 'Google Stadia',
    logo: '🌐',
    launchDate: '2019-11-19',
    endDate: '2023-01-18',
    description: 'Google Stadia was a cloud gaming service combining a WiFi gaming controller a...',
  },
  {
    id: '99919',
    name: 'App Maker',
    logo: '🌐',
    launchDate: '2016-11-30',
    endDate: '2021-01-19',
    description: 'App Maker was a tool that allowed its users to build and deploy custom busine...',
  },
  {
    id: '99920',
    name: 'Google Web Accelerator',
    logo: '🌐',
    launchDate: '2005-05-04',
    endDate: '2008-01-20',
    description: 'Google Web Accelerator was a client-side software that increased the load spe...',
  },
  {
    id: '99921',
    name: 'Firefox 3.5',
    logo: '🦊',
    launchDate: '2009-06-30',
    endDate: '2011-01-21',
    description: 'Popular Firefox browser version',
  },
  {
    id: '99922',
    name: 'Loon',
    logo: '🌐',
    launchDate: '2014-06-14',
    endDate: '2021-01-22',
    description: 'Loon was a service to provide internet access via an array of high-altitude b...',
  },
  {
    id: '99923',
    name: 'Gmailify',
    logo: '📧',
    launchDate: '2016-02-17',
    endDate: '2026-01-23',
    description: 'Gmail features for third-party email accounts',
  },
  {
    id: '99924',
    name: 'Orkut',
    logo: '🔵',
    launchDate: '2004-01-24',
    endDate: '2014-01-24',
    description: 'Google social network popular in Brazil',
  },
  {
    id: '99925',
    name: 'Google Code Search',
    logo: '🔍',
    launchDate: '2006-10-05',
    endDate: '2012-01-25',
    description: 'Source code search engine',
  },
  {
    id: '99926',
    name: 'Tilt Brush',
    logo: '📱',
    launchDate: '2016-04-05',
    endDate: '2021-01-26',
    description: 'Tilt Brush was a room-scale 3D-painting virtual-reality application available...',
  },
  {
    id: '99927',
    name: 'Microsoft Visual SourceSafe',
    logo: '📱',
    launchDate: '1994-01-01',
    endDate: '2006-01-27',
    description: 'Microsoft Visual SourceSafe (VSS) was a source control program oriented towar...',
  },
  {
    id: '99928',
    name: 'My Tracks',
    logo: '🏃',
    launchDate: '2009-05-28',
    endDate: '2016-01-28',
    description: 'GPS tracking app for fitness activities',
  },
  {
    id: '99929',
    name: 'People',
    logo: '📱',
    launchDate: '2016-01-01',
    endDate: '2021-01-29',
    description: 'People was a contact management app and address book included in Windows 8 an...',
  },
  {
    id: '99930',
    name: 'DirectSound3D',
    logo: '🌐',
    launchDate: '1996-01-01',
    endDate: '2007-01-30',
    description: 'DirectSound3D was an extension to DirectSound to standardize real-time 3D aud...',
  },
  {
    id: '99931',
    name: 'Microsoft XNA',
    logo: '📱',
    launchDate: '2006-03-14',
    endDate: '2013-01-31',
    description: 'Microsoft XNA was a freeware set of tools with a managed runtime environment ...',
  },
  {
    id: '99932',
    name: 'Project Origami',
    logo: '🔧',
    launchDate: '2006-02-25',
    endDate: '2010-02-01',
    description: 'Project Origami was the code name for ultra-mobile PCs (also known as ultra-m...',
  },
  {
    id: '99933',
    name: 'Windows Mobile',
    logo: '💻',
    launchDate: '2000-04-19',
    endDate: '2010-02-02',
    description: 'Windows Mobile was a family of mobile operating systems developed by Microsof...',
  },
  {
    id: '99934',
    name: 'Adobe Animate (announced)',
    logo: '🎬',
    launchDate: '1996-05-01',
    endDate: '2026-02-03',
    description: '2D animation software formerly known as Flash',
  },
  {
    id: '99935',
    name: 'Google Fiber TV',
    logo: '🌐',
    launchDate: '2012-12-12',
    endDate: '2020-02-04',
    description: 'Google Fiber TV was an IPTV service that was bundled with Google Fiber.',
  },
  {
    id: '99936',
    name: 'Posterous',
    logo: '📝',
    launchDate: '2008-05-28',
    endDate: '2013-02-05',
    description: 'Simple blogging platform acquired by Twitter',
  },
  {
    id: '99937',
    name: 'One Today',
    logo: '📱',
    launchDate: '2013-04-18',
    endDate: '2020-02-06',
    description: 'One Today was an app that allowed users to donate $1 to different organizatio...',
  },
  {
    id: '99938',
    name: 'Google Schemer',
    logo: '🌐',
    launchDate: '2011-07-01',
    endDate: '2014-02-07',
    description: 'Google Schemer was a Google service for sharing and discovering things to do.',
  },
  {
    id: '99939',
    name: 'Google Hands Free',
    logo: '🌐',
    launchDate: '2016-03-02',
    endDate: '2017-02-08',
    description: 'Google Hands Free was a mobile payment system that allowed users to pay their...',
  },
  {
    id: '99940',
    name: 'Apple MobileMe Gallery',
    logo: '📸',
    launchDate: '2008-07-11',
    endDate: '2012-02-09',
    description: 'Online photo and video gallery',
  },
  {
    id: '99941',
    name: 'Real Estate On Google Maps',
    logo: '🌐',
    launchDate: '2009-07-01',
    endDate: '2011-02-10',
    description: 'Real Estate on Google Maps enabled users to find places for sale or rent in a...',
  },
  {
    id: '99942',
    name: 'Windows Live Essentials 2009',
    logo: '💻',
    launchDate: '2009-01-08',
    endDate: '2014-02-11',
    description: 'Suite of desktop applications',
  },
  {
    id: '99943',
    name: 'Google Audio Ads',
    logo: '🌐',
    launchDate: '2008-07-08',
    endDate: '2009-02-12',
    description: 'Google Audio Ads service allowed advertisers to run campaigns on AM/FM radio ...',
  },
  {
    id: '99944',
    name: 'Windows Live Mesh',
    logo: '📱',
    launchDate: '2010-09-30',
    endDate: '2013-02-13',
    description: 'Windows Live Mesh (formerly known as Windows Live FolderShare, Live Mesh, and...',
  },
  {
    id: '99945',
    name: 'Windows Virtual PC',
    logo: '📱',
    launchDate: '1997-06-01',
    endDate: '2011-02-14',
    description: 'Windows Virtual PC (formerly Microsoft Virtual PC 2007, Microsoft Virtual PC ...',
  },
  {
    id: '99946',
    name: 'MSN Messenger',
    logo: '📱',
    launchDate: '1999-07-22',
    endDate: '2013-02-15',
    description: 'MSN Messenger (later rebranded as Windows Live Messenger) was a cross-platfor...',
  },
  {
    id: '99947',
    name: 'Microsoft Reader',
    logo: '📱',
    launchDate: '2011-12-07',
    endDate: '2018-02-16',
    description: 'Microsoft Reader was an app to read PDF, XPS and TIFF files by Microsoft. It ...',
  },
  {
    id: '99948',
    name: 'Google Station',
    logo: '🌐',
    launchDate: '2015-09-27',
    endDate: '2020-02-17',
    description: 'Google Station was a service that gave partners an easy set of tools to roll ...',
  },
  {
    id: '99949',
    name: 'Pie',
    logo: '🌐',
    launchDate: '2013-06-01',
    endDate: '2016-02-18',
    description: 'Pie was a work-centric group chat website and app comparable to Slack.',
  },
  {
    id: '99950',
    name: 'Marratech e-meetings',
    logo: '🌐',
    launchDate: '1998-11-30',
    endDate: '2010-02-19',
    description: 'Marratech was a Swedish company that made software for e-meetings (e.g., web ...',
  },
  {
    id: '99951',
    name: 'Netscape Navigator 9',
    logo: '⛵',
    launchDate: '2007-10-15',
    endDate: '2008-02-20',
    description: 'Final version of the Netscape browser',
  },
  {
    id: '99952',
    name: 'Google Maps Coordinate',
    logo: '🌐',
    launchDate: '2012-06-21',
    endDate: '2016-02-21',
    description: 'Google Maps Coordinate was a service for managing mobile workforces with the ...',
  },
  {
    id: '99953',
    name: 'AT&T 3G Network',
    logo: '📶',
    launchDate: '2004-10-21',
    endDate: '2022-02-22',
    description: 'Third-generation cellular network',
  },
  {
    id: '99954',
    name: 'Google Code Competitions',
    logo: '🌐',
    launchDate: '2003-10-01',
    endDate: '2023-02-23',
    description: 'Google Code Jam, Kick Start, and Hash Code were competitive programming compe...',
  },
  {
    id: '99955',
    name: 'Google Inbox',
    logo: '📬',
    launchDate: '2014-10-22',
    endDate: '2019-02-24',
    description: 'Alternative email interface by Google',
  },
  {
    id: '99956',
    name: 'Google Chrome Frame',
    logo: '🖼️',
    launchDate: '2009-09-22',
    endDate: '2014-02-25',
    description: 'Plugin to run Chrome engine inside IE',
  },
  {
    id: '99957',
    name: 'Yammer Enterprise (legacy)',
    logo: '💬',
    launchDate: '2008-09-08',
    endDate: '2017-02-26',
    description: 'Enterprise social networking platform',
  },
  {
    id: '99958',
    name: 'Microsoft Digital Image',
    logo: '🖼️',
    launchDate: '2002-09-01',
    endDate: '2007-02-27',
    description: 'Photo editing and management suite',
  },
  {
    id: '99959',
    name: 'Dodgeball',
    logo: '🌐',
    launchDate: '2003-06-30',
    endDate: '2009-02-28',
    description: 'Dodgeball was a location-based social network where users texted their locati...',
  },
  {
    id: '99960',
    name: 'Windows Embedded Automotive',
    logo: '💻',
    launchDate: '1998-12-04',
    endDate: '2011-03-01',
    description: 'Windows Embedded Automotive (formerly Microsoft Auto, Windows CE for Automoti...',
  },
  {
    id: '99961',
    name: 'Readability',
    logo: '📖',
    launchDate: '2009-09-01',
    endDate: '2016-03-02',
    description: 'Article reading and bookmarking service',
  },
  {
    id: '99962',
    name: 'Google Cardboard',
    logo: '🔧',
    launchDate: '2014-06-25',
    endDate: '2021-03-03',
    description: 'Google Cardboard was a low-cost, virtual reality (VR) platform named after it...',
  },
  {
    id: '99963',
    name: 'Google Maps Navigation (standalone)',
    logo: '🧭',
    launchDate: '2009-10-28',
    endDate: '2020-03-04',
    description: 'Free turn-by-turn GPS navigation',
  },
  {
    id: '99964',
    name: 'Windows Subsystem for Android',
    logo: '📱',
    launchDate: '2022-02-15',
    endDate: '2025-03-05',
    description: 'Windows Subsystem for Android was a feature of Windows 11 which allows users ...',
  },
  {
    id: '99965',
    name: 'Slide',
    logo: '🌐',
    launchDate: '2005-05-01',
    endDate: '2012-03-06',
    description: 'Slide was a photo sharing software for social networking services such as MyS...',
  },
  {
    id: '99966',
    name: 'Google Notification Widget (Mr. Jingles)',
    logo: '🌐',
    launchDate: '2015-06-01',
    endDate: '2019-03-07',
    description: 'Mr. Jingles (aka Google Notification Widget) displayed alerts and notificatio...',
  },
  {
    id: '99967',
    name: 'Samsung ChatON',
    logo: '💬',
    launchDate: '2011-10-01',
    endDate: '2015-03-08',
    description: 'Samsung messaging service',
  },
  {
    id: '99968',
    name: 'Microsoft Lync 2010',
    logo: '📞',
    launchDate: '2010-11-17',
    endDate: '2015-03-09',
    description: 'Enterprise communication platform',
  },
  {
    id: '99969',
    name: 'AltspaceVR',
    logo: '🌐',
    launchDate: '2015-01-30',
    endDate: '2023-03-10',
    description: 'AltspaceVR was a vibrant, community-centric, VR platform (acquired in 2017), ...',
  },
  {
    id: '99970',
    name: 'Grand Central',
    logo: '🌐',
    launchDate: '2005-01-01',
    endDate: '2009-03-11',
    description: 'Grand Central was a Voice over IP service that was acquired by Google, and tu...',
  },
  {
    id: '99971',
    name: 'Google MySpace partnership',
    logo: '🤝',
    launchDate: '2006-08-07',
    endDate: '2010-03-12',
    description: 'Google-powered MySpace search deal',
  },
  {
    id: '99972',
    name: 'Google Allo',
    logo: '📱',
    launchDate: '2016-09-21',
    endDate: '2019-03-13',
    description: 'Google Allo was an instant messaging mobile app for Android, iOS, and Web wit...',
  },
  {
    id: '99973',
    name: 'Wildfire Interactive',
    logo: '🌐',
    launchDate: '2012-07-31',
    endDate: '2014-03-14',
    description: 'Wildfire by Google was a social marketing application that enabled businesses...',
  },
  {
    id: '99974',
    name: 'BebaPay',
    logo: '🌐',
    launchDate: '2013-04-30',
    endDate: '2015-03-15',
    description: 'BebaPay was a form of electronic ticketing platform in Nairobi, Kenya that wa...',
  },
  {
    id: '99975',
    name: 'Magento Commerce 1.x',
    logo: '🛒',
    launchDate: '2008-03-31',
    endDate: '2020-03-16',
    description: 'Open-source e-commerce platform',
  },
  {
    id: '99976',
    name: 'Jacquard',
    logo: '🔧',
    launchDate: '2014-01-01',
    endDate: '2023-03-17',
    description: 'Jacquard was a small tag to make it easier and more intuitive for people to i...',
  },
  {
    id: '99977',
    name: 'Microsoft Digital Media Pro Keyboard',
    logo: '⌨️',
    launchDate: '2005-09-01',
    endDate: '2014-03-18',
    description: 'Multimedia keyboard',
  },
  {
    id: '99978',
    name: 'Material Theme Editor',
    logo: '📱',
    launchDate: '2018-05-09',
    endDate: '2020-03-19',
    description: 'Material Theme Editor was a plugin for Sketch App which allowed you to create...',
  },
  {
    id: '99979',
    name: 'YouTube for PS Vita',
    logo: '📱',
    launchDate: '2012-06-26',
    endDate: '2015-03-20',
    description: 'YouTube for PlayStation Vita was a native YouTube browsing and viewing applic...',
  },
  {
    id: '99980',
    name: 'Google Street View (standalone app)',
    logo: '📱',
    launchDate: '2010-09-09',
    endDate: '2023-03-21',
    description: 'Google Street View app was an Android and iOS app that enabled people to get ...',
  },
  {
    id: '99981',
    name: 'Microsoft NetMeeting',
    logo: '📱',
    launchDate: '1996-05-29',
    endDate: '2007-03-22',
    description: 'Microsoft NetMeeting was VoIP and multi-point videoconferencing client and in...',
  },
  {
    id: '99982',
    name: 'Google Catalogs (mobile)',
    logo: '📖',
    launchDate: '2013-08-15',
    endDate: '2015-03-23',
    description: 'Digital catalog browsing app',
  },
  {
    id: '99983',
    name: 'Tay',
    logo: '🌐',
    launchDate: '2016-03-23',
    endDate: '2016-03-24',
    description: 'Tay was a chatbot that was shutdown after only 16 hours since it began to pos...',
  },
  {
    id: '99984',
    name: 'Nokia HERE Maps (Windows)',
    logo: '🗺️',
    launchDate: '2012-11-28',
    endDate: '2016-03-25',
    description: 'Navigation app for Windows Phone',
  },
  {
    id: '99985',
    name: 'Adobe Muse',
    logo: '🎨',
    launchDate: '2012-08-20',
    endDate: '2020-03-26',
    description: 'Code-free website design tool',
  },
  {
    id: '99986',
    name: 'Microsoft Expression Studio 4',
    logo: '🎨',
    launchDate: '2010-06-07',
    endDate: '2013-03-27',
    description: 'Web and desktop design suite',
  },
  {
    id: '99987',
    name: 'Urchin',
    logo: '🌐',
    launchDate: '2005-04-30',
    endDate: '2012-03-28',
    description: 'Urchin was a web statistics analysis program developed by Urchin Software Cor...',
  },
  {
    id: '99988',
    name: 'Jawbone UP',
    logo: '⌚',
    launchDate: '2011-11-06',
    endDate: '2017-03-29',
    description: 'Fitness tracker and health platform',
  },
  {
    id: '99989',
    name: 'Google Shared Stuff',
    logo: '🌐',
    launchDate: '2007-09-30',
    endDate: '2009-03-30',
    description: 'Google Shared Stuff was a web page sharing system that allowed users to bookm...',
  },
  {
    id: '99990',
    name: 'Google Go Links',
    logo: '🌐',
    launchDate: '2010-01-01',
    endDate: '2021-03-31',
    description: '(also known as Google Short Links) was a URL shortening service. It also supp...',
  },
  {
    id: '2001',
    name: 'LimeWire',
    logo: '🍋',
    launchDate: '2000-05-03',
    endDate: '2010-10-26',
    description: 'Peer-to-peer file sharing client for Gnutella network',
  },
  {
    id: '2002',
    name: 'MegaUpload',
    logo: '☁️',
    launchDate: '2005-03-21',
    endDate: '2012-01-19',
    description: 'Popular file hosting and sharing service, shut down by the US government',
  },
  {
    id: '2003',
    name: 'RapidShare',
    logo: '⚡',
    launchDate: '2002-05-01',
    endDate: '2015-03-31',
    description: 'One-click file hosting service for easy file sharing',
  },
  {
    id: '2004',
    name: 'Grooveshark',
    logo: '🦈',
    launchDate: '2006-03-01',
    endDate: '2015-04-30',
    description: 'Music streaming and sharing platform, closed due to legal issues',
  },
  {
    id: '2005',
    name: 'eDonkey2000',
    logo: '🐴',
    launchDate: '2000-09-06',
    endDate: '2005-09-28',
    description: 'Peer-to-peer file sharing application using the eDonkey network',
  },
  {
    id: '2006',
    name: 'Hotfile',
    logo: '🔥',
    launchDate: '2006-06-01',
    endDate: '2013-12-04',
    description: 'File hosting and sharing service, closed after legal settlement',
  },
  {
    id: '2007',
    name: 'FileSonic',
    logo: '🌊',
    launchDate: '2010-08-01',
    endDate: '2012-01-30',
    description: 'File hosting and sharing service, disabled sharing after MegaUpload takedown',
  },
  {
    id: '2008',
    name: 'Mininova',
    logo: '🌀',
    launchDate: '2005-01-15',
    endDate: '2017-04-04',
    description: 'BitTorrent index and search engine, removed infringing torrents in 2009',
  },
  {
    id: '2009',
    name: 'IsoHunt',
    logo: '🔍',
    launchDate: '2003-01-01',
    endDate: '2013-10-23',
    description: 'BitTorrent index with millions of torrents, shut down after lawsuit',
  },
  {
    id: '2010',
    name: 'Audiogalaxy',
    logo: '🎧',
    launchDate: '1998-01-01',
    endDate: '2013-01-01',
    description: 'Music sharing service, later became a streaming platform',
  },
  {
    id: '3001',
    name: 'KickassTorrents (KAT)',
    logo: '🦜',
    launchDate: '2008-11-15',
    endDate: '2016-07-20',
    description:
      'One of the largest and most popular torrent indexers, shut down by US authorities.',
  },
  {
    id: '3002',
    name: 'ExtraTorrent',
    logo: '💥',
    launchDate: '2006-11-15',
    endDate: '2017-05-17',
    description:
      'Major torrent site known for its large community and database, voluntarily shut down.',
  },
  {
    id: '3003',
    name: 'Torrentz',
    logo: '🔎',
    launchDate: '2003-07-24',
    endDate: '2016-08-05',
    description: 'Popular torrent meta-search engine, closed voluntarily.',
  },
  {
    id: '3004',
    name: 'Demonoid',
    logo: '👹',
    launchDate: '2003-04-21',
    endDate: '2018-09-17',
    description:
      'Long-running semi-private torrent tracker, plagued by shutdowns and legal issues.',
  },
  {
    id: '3005',
    name: 'YTS (YIFY)',
    logo: '🎬',
    launchDate: '2010-08-01',
    endDate: '2015-10-30',
    description: 'Famous for high-quality movie torrents, shut down after legal action.',
  },
  {
    id: '3006',
    name: 'TorrentHound',
    logo: '🐺',
    launchDate: '2007-01-01',
    endDate: '2016-09-15',
    description: 'Popular torrent index, closed voluntarily citing legal pressure.',
  },
  {
    id: '3007',
    name: 'TorrentProject',
    logo: '📡',
    launchDate: '2010-01-01',
    endDate: '2017-09-15',
    description: 'Meta-search engine for torrents, went offline without notice.',
  },
  {
    id: '3008',
    name: 'BitSnoop',
    logo: '🐙',
    launchDate: '2008-01-01',
    endDate: '2017-04-01',
    description: 'Indexed over 24 million torrents, shut down after legal threats.',
  },
  {
    id: '3009',
    name: 'Fenopy',
    logo: '🧊',
    launchDate: '2006-01-01',
    endDate: '2014-03-01',
    description: 'Torrent indexer with social features, went offline.',
  },
  {
    id: '3010',
    name: 'SumoTorrent',
    logo: '🦦',
    launchDate: '2007-01-01',
    endDate: '2017-01-01',
    description: 'Torrent site with a large database, eventually shut down.',
  },
  {
    id: '3011',
    name: 'YourBittorrent (original)',
    logo: '🧩',
    launchDate: '2003-11-01',
    endDate: '2008-01-01',
    description: 'Original version of YourBittorrent, split from MyBittorrent.',
  },
  {
    id: '3012',
    name: 'TorrentReactor',
    logo: '⚛️',
    launchDate: '2003-01-01',
    endDate: '2021-01-01',
    description: 'One of the oldest torrent sites, eventually went offline.',
  },
  {
    id: '3013',
    name: 'BTDigg',
    logo: '🔗',
    launchDate: '2011-01-01',
    endDate: '2017-01-01',
    description: 'First DHT search engine for BitTorrent, went offline.',
  },
  {
    id: '3014',
    name: 'TorrentFunk',
    logo: '🎸',
    launchDate: '2011-01-01',
    endDate: '2019-01-01',
    description: 'Torrent indexer with user ratings, eventually shut down.',
  },
  {
    id: '3015',
    name: 'Monova',
    logo: '🦑',
    launchDate: '2004-01-01',
    endDate: '2018-01-01',
    description: 'Torrent indexer, went offline after years of operation.',
  },
  {
    id: '3016',
    name: 'BTScene',
    logo: '🎭',
    launchDate: '2008-01-01',
    endDate: '2019-01-01',
    description: 'Torrent site with a large database, eventually shut down.',
  },
  {
    id: '3017',
    name: 'Torlock',
    logo: '🔒',
    launchDate: '2010-01-01',
    endDate: '2020-01-01',
    description: 'Torrent indexer, known for paying users to report fake torrents.',
  },
  {
    id: '3018',
    name: 'TorrentDownloads',
    logo: '📥',
    launchDate: '2007-01-01',
    endDate: '2020-01-01',
    description: 'Popular torrent index, eventually went offline.',
  },
  {
    id: '3019',
    name: 'TorrentMatrix',
    logo: '🧮',
    launchDate: '2003-01-01',
    endDate: '2014-01-01',
    description: 'Early torrent indexer, shut down after legal threats.',
  },
  {
    id: '3020',
    name: 'TorrentPortal',
    logo: '🚪',
    launchDate: '2003-01-01',
    endDate: '2017-01-01',
    description: 'Torrent indexer, eventually went offline.',
  },
  {
    id: '3021',
    name: 'Direct Connect',
    logo: '🔗',
    launchDate: '2001-11-01',
    endDate: '2011-01-01',
    description:
      'Peer-to-peer file sharing protocol and network, popular for hubs and community sharing.',
  },
  {
    id: '3022',
    name: 'DC++',
    logo: '💠',
    launchDate: '2003-01-01',
    endDate: '2018-01-01',
    description: 'Open-source client for the Direct Connect network, widely used for file sharing.',
  },
  {
    id: '3023',
    name: 'Shareaza',
    logo: '🌀',
    launchDate: '2002-06-01',
    endDate: '2019-01-01',
    description:
      'Multi-network peer-to-peer file sharing client supporting Gnutella, eDonkey, BitTorrent, and more.',
  },
  // New entries to fill missing MM-DD combinations
  {
    id: '4001',
    name: 'Silverlight',
    logo: '🌙',
    launchDate: '2007-04-20',
    endDate: '2021-10-12',
    description: 'Microsoft web application framework for rich media experiences',
  },
  {
    id: '4002',
    name: 'Windows Live Spaces',
    logo: '🌐',
    launchDate: '2004-12-01',
    endDate: '2011-04-03',
    description: 'Customizable web space and blogging platform by Microsoft',
  },
  {
    id: '4003',
    name: 'Digg',
    logo: '⬆️',
    launchDate: '2004-12-01',
    endDate: '2012-04-06',
    description: 'Social news aggregation and rating platform',
  },
  {
    id: '4004',
    name: 'Yahoo Pipes',
    logo: '🔀',
    launchDate: '2007-02-09',
    endDate: '2015-04-07',
    description: 'Data mashup composition platform by Yahoo',
  },
  {
    id: '4005',
    name: 'Readability',
    logo: '📖',
    launchDate: '2010-02-23',
    endDate: '2016-04-10',
    description: 'Article reading and bookmarking service',
  },
  {
    id: '4006',
    name: 'Adobe Fireworks',
    logo: '🎆',
    launchDate: '1998-04-01',
    endDate: '2013-04-16',
    description: 'Bitmap and vector graphics editor',
  },
  {
    id: '4007',
    name: 'Orkut',
    logo: '🔵',
    launchDate: '2004-01-24',
    endDate: '2014-04-17',
    description: 'Google social network popular in Brazil and India',
  },
  {
    id: '4008',
    name: 'StubHub Resale',
    logo: '🎫',
    launchDate: '2000-11-15',
    endDate: '2012-04-18',
    description: 'Event ticket resale marketplace',
  },
  {
    id: '4009',
    name: 'Delicious',
    logo: '🔖',
    launchDate: '2003-09-09',
    endDate: '2017-04-19',
    description: 'Social bookmarking and link sharing service',
  },
  {
    id: '4010',
    name: 'MobileMe',
    logo: '☁️',
    launchDate: '2008-07-11',
    endDate: '2012-04-21',
    description: "Apple's cloud storage and sync service predecessor to iCloud",
  },
  {
    id: '4011',
    name: 'Yahoo Directory',
    logo: '📚',
    launchDate: '1994-02-01',
    endDate: '2014-05-03',
    description: 'Web directory and search portal',
  },
  {
    id: '4012',
    name: 'Google Checkout',
    logo: '💳',
    launchDate: '2006-06-29',
    endDate: '2013-05-05',
    description: 'Online payment and checkout service by Google',
  },
  {
    id: '4013',
    name: 'Hangouts',
    logo: '💬',
    launchDate: '2013-05-15',
    endDate: '2022-12-01',
    description: 'Google messaging and video calling platform',
  },
  {
    id: '4014',
    name: 'Windows Live SkyDrive',
    logo: '☁️',
    launchDate: '2007-08-01',
    endDate: '2014-05-08',
    description: 'Cloud storage service predecessor to OneDrive',
  },
  {
    id: '4015',
    name: 'Flock Browser',
    logo: '🦅',
    launchDate: '2005-10-20',
    endDate: '2011-05-09',
    description: 'Social web browser with integrated media sharing',
  },
  {
    id: '4016',
    name: 'Groove',
    logo: '🎶',
    launchDate: '2015-04-27',
    endDate: '2020-05-16',
    description: 'Microsoft music streaming service',
  },
  {
    id: '4017',
    name: 'Fitbit Flex',
    logo: '⌚',
    launchDate: '2013-05-06',
    endDate: '2016-05-20',
    description: 'Wearable fitness tracker device',
  },
  {
    id: '4018',
    name: 'Google Latitude',
    logo: '📍',
    launchDate: '2009-02-04',
    endDate: '2013-05-22',
    description: 'Location sharing service on Google Maps',
  },
  {
    id: '4019',
    name: 'Pownce',
    logo: '🎯',
    launchDate: '2007-07-15',
    endDate: '2008-05-24',
    description: 'Social media sharing service acquired by Six Apart',
  },
  {
    id: '4020',
    name: 'Slide',
    logo: '🎬',
    launchDate: '2005-05-01',
    endDate: '2012-05-26',
    description: 'Photo sharing widget for social networks',
  },
  {
    id: '4021',
    name: 'Windows Phone 7',
    logo: '📱',
    launchDate: '2010-10-21',
    endDate: '2014-05-30',
    description: "Microsoft's mobile operating system with Metro UI",
  },
  {
    id: '4022',
    name: 'Google Buzz',
    logo: '🐝',
    launchDate: '2010-02-09',
    endDate: '2011-06-02',
    description: 'Social networking feature in Gmail',
  },
  {
    id: '4023',
    name: 'Vimeo Social Features',
    logo: '🎥',
    launchDate: '2005-11-01',
    endDate: '2015-06-03',
    description: 'Video hosting service social component',
  },
  {
    id: '4024',
    name: 'Yahoo Meme',
    logo: '📸',
    launchDate: '2010-06-01',
    endDate: '2011-06-05',
    description: 'Meme sharing and remixing service',
  },
  {
    id: '4025',
    name: 'Picasa Web Albums',
    logo: '📸',
    launchDate: '2006-01-19',
    endDate: '2016-06-08',
    description: 'Google photo sharing service',
  },
  {
    id: '4026',
    name: 'Favstar',
    logo: '⭐',
    launchDate: '2009-01-01',
    endDate: '2017-06-09',
    description: 'Twitter favorite archiving service',
  },
  {
    id: '4027',
    name: 'StumbleUpon',
    logo: '🎲',
    launchDate: '2002-11-01',
    endDate: '2018-06-10',
    description: 'Web discovery and rating platform',
  },
  {
    id: '4028',
    name: 'Google Reader',
    logo: '📰',
    launchDate: '2005-10-07',
    endDate: '2013-06-11',
    description: 'RSS feed reader and aggregator',
  },
  {
    id: '4029',
    name: 'iMeem',
    logo: '🎵',
    launchDate: '2006-09-01',
    endDate: '2009-06-12',
    description: 'Music sharing and streaming service',
  },
  {
    id: '4030',
    name: 'Posterous',
    logo: '📝',
    launchDate: '2008-05-28',
    endDate: '2013-06-19',
    description: 'Simple blogging platform acquired by Twitter',
  },
  {
    id: '4031',
    name: 'AOL Search',
    logo: '🔎',
    launchDate: '2005-01-18',
    endDate: '2006-06-20',
    description: 'AOL search engine powered by Google',
  },
  {
    id: '4032',
    name: 'Mint.com Task Planner',
    logo: '📋',
    launchDate: '2007-09-12',
    endDate: '2012-06-22',
    description: 'Financial management and task planning service',
  },
  {
    id: '4033',
    name: 'News Knob',
    logo: '🔊',
    launchDate: '2005-06-01',
    endDate: '2008-06-25',
    description: 'Personalized news search engine',
  },
  {
    id: '4034',
    name: 'Zoho Show',
    logo: '🎨',
    launchDate: '2006-01-01',
    endDate: '2015-06-27',
    description: 'Web-based presentation software',
  },
  {
    id: '4035',
    name: 'Nimbuzz',
    logo: '📱',
    launchDate: '2007-12-01',
    endDate: '2012-06-29',
    description: 'Multi-protocol instant messaging client',
  },
  {
    id: '4036',
    name: 'Google Video',
    logo: '🎥',
    launchDate: '2005-01-25',
    endDate: '2012-07-02',
    description: 'Video hosting and search service',
  },
  {
    id: '4037',
    name: 'iRiver',
    logo: '🎵',
    launchDate: '1999-10-01',
    endDate: '2010-07-04',
    description: 'Digital audio player brand',
  },
  {
    id: '4038',
    name: 'Windows Mobile Device Center',
    logo: '📱',
    launchDate: '2005-11-01',
    endDate: '2011-07-05',
    description: 'Device synchronization software for Windows Mobile',
  },
  {
    id: '4039',
    name: 'Slacker',
    logo: '🎧',
    launchDate: '2007-06-01',
    endDate: '2010-07-07',
    description: 'Online radio and music streaming service',
  },
  {
    id: '4040',
    name: 'Windows Live Family Safety',
    logo: '👨‍👩‍👧‍👦',
    launchDate: '2007-01-30',
    endDate: '2012-07-09',
    description: 'Parental control software by Microsoft',
  },
  {
    id: '4041',
    name: 'Foursquare (original)',
    logo: '📍',
    launchDate: '2009-03-09',
    endDate: '2014-07-16',
    description: 'Location-based social networking service',
  },
  {
    id: '4042',
    name: 'Airtight Networks',
    logo: '🔒',
    launchDate: '2005-02-01',
    endDate: '2012-07-19',
    description: 'Wireless security software',
  },
  {
    id: '4043',
    name: 'Google Health',
    logo: '🏥',
    launchDate: '2008-05-20',
    endDate: '2012-07-21',
    description: 'Personal health record service',
  },
  {
    id: '4044',
    name: 'Hulu Plus Original UI',
    logo: '🎬',
    launchDate: '2010-06-29',
    endDate: '2012-07-23',
    description: 'Video streaming service interface',
  },
  {
    id: '4045',
    name: 'Netflix Qwikster',
    logo: '🎬',
    launchDate: '2011-07-13',
    endDate: '2011-07-24',
    description: 'Netflix DVD rental spinoff (cancelled)',
  },
  {
    id: '4046',
    name: 'Windows Live Events',
    logo: '🎊',
    launchDate: '2008-09-15',
    endDate: '2011-07-26',
    description: 'Event planning and coordination service',
  },
  {
    id: '4047',
    name: 'Yahoo Answers',
    logo: '❓',
    launchDate: '2005-06-28',
    endDate: '2021-07-28',
    description: 'Q&A community platform',
  },
  {
    id: '4048',
    name: 'Fringilla',
    logo: '🎵',
    launchDate: '2005-11-01',
    endDate: '2010-07-29',
    description: 'Music recommendation and streaming service',
  },
  {
    id: '4049',
    name: 'Windows Live Expo',
    logo: '🛍️',
    launchDate: '2006-05-01',
    endDate: '2010-07-31',
    description: 'Online classified advertising service',
  },
  {
    id: '4050',
    name: 'Google Gears',
    logo: '⚙️',
    launchDate: '2007-05-30',
    endDate: '2011-08-01',
    description: 'Browser plugin for offline web applications',
  },
  {
    id: '4051',
    name: 'JoinIn',
    logo: '🤝',
    launchDate: '2008-06-01',
    endDate: '2012-08-02',
    description: 'Collaborative shopping platform',
  },
  {
    id: '4052',
    name: 'Qwest Fusion',
    logo: '🔄',
    launchDate: '2006-01-01',
    endDate: '2011-08-03',
    description: 'Internet service provider portal',
  },
  {
    id: '4053',
    name: 'Dodgeball',
    logo: '⚽',
    launchDate: '2005-05-11',
    endDate: '2009-08-05',
    description: 'Location-based social networking acquired by Google',
  },
  {
    id: '4054',
    name: 'Imified',
    logo: '💬',
    launchDate: '2007-03-15',
    endDate: '2010-08-06',
    description: 'Instant messaging gateway service',
  },
  {
    id: '4055',
    name: 'Zoho Chat',
    logo: '💬',
    launchDate: '2007-01-01',
    endDate: '2012-08-08',
    description: 'Web-based team chat application',
  },
  {
    id: '4056',
    name: 'ConnectU',
    logo: '🤝',
    launchDate: '2002-01-01',
    endDate: '2008-08-11',
    description: 'Social networking site precursor to Facebook',
  },
  {
    id: '4057',
    name: 'HP WebOS',
    logo: '📱',
    launchDate: '2009-06-06',
    endDate: '2015-08-12',
    description: "HP's mobile and tablet operating system",
  },
  {
    id: '4058',
    name: 'Zune Pass',
    logo: '🎶',
    launchDate: '2006-11-14',
    endDate: '2014-08-14',
    description: 'Music subscription service by Microsoft',
  },
  {
    id: '4059',
    name: 'Twhirl',
    logo: '🐦',
    launchDate: '2007-08-01',
    endDate: '2009-08-15',
    description: 'Adobe AIR-based Twitter and Friendfeed client',
  },
  {
    id: '4060',
    name: 'Bitdefender Safepay',
    logo: '🔒',
    launchDate: '2009-06-01',
    endDate: '2012-08-16',
    description: 'Secure shopping browser extension',
  },
  {
    id: '4061',
    name: 'Wakoopa',
    logo: '💻',
    launchDate: '2007-01-01',
    endDate: '2014-08-22',
    description: 'Software tracking and recommendation platform',
  },
  {
    id: '4062',
    name: 'GetJar',
    logo: '📱',
    launchDate: '2004-03-01',
    endDate: '2018-08-23',
    description: 'Mobile app store and distribution platform',
  },
  {
    id: '4063',
    name: 'Hyves',
    logo: '🌐',
    launchDate: '2004-09-01',
    endDate: '2011-08-24',
    description: 'Dutch social networking platform',
  },
  {
    id: '4064',
    name: 'TweetPie',
    logo: '🥧',
    launchDate: '2009-05-01',
    endDate: '2012-08-25',
    description: 'Twitter analytics service',
  },
  {
    id: '4065',
    name: 'Widgetsmith',
    logo: '📱',
    launchDate: '2020-04-02',
    endDate: '2023-08-27',
    description: 'iOS widget creation app',
  },
  {
    id: '4066',
    name: 'Vimeo Plus',
    logo: '🎬',
    launchDate: '2009-06-01',
    endDate: '2014-08-28',
    description: 'Video hosting premium features',
  },
  {
    id: '4067',
    name: 'Flock Browser (2nd gen)',
    logo: '🦅',
    launchDate: '2010-05-01',
    endDate: '2011-08-31',
    description: 'Social web browser revival',
  },
  {
    id: '4068',
    name: 'GrandCentral',
    logo: '📞',
    launchDate: '2005-01-01',
    endDate: '2009-09-02',
    description: 'VoIP service acquired by Google',
  },
  {
    id: '4069',
    name: 'Pandora (original)',
    logo: '📻',
    launchDate: '2005-01-13',
    endDate: '2013-09-05',
    description: 'Internet radio and personalized music recommendation',
  },
  {
    id: '4070',
    name: 'Airtime',
    logo: '🎵',
    launchDate: '2011-04-04',
    endDate: '2014-09-06',
    description: 'Music discovery and streaming platform',
  },
  {
    id: '4071',
    name: 'Moshi Monsters',
    logo: '👹',
    launchDate: '2008-06-01',
    endDate: '2019-09-08',
    description: 'Online virtual pet game and social platform',
  },
  {
    id: '4072',
    name: 'Vlingo',
    logo: '🎤',
    launchDate: '2007-12-01',
    endDate: '2014-09-09',
    description: 'Voice command application',
  },
  {
    id: '4073',
    name: 'Eventbrite Ticketing Legacy',
    logo: '🎫',
    launchDate: '2006-01-01',
    endDate: '2013-09-15',
    description: 'Event ticketing and registration platform',
  },
  {
    id: '4074',
    name: 'FourSquare Swarm',
    logo: '👻',
    launchDate: '2009-03-09',
    endDate: '2017-09-16',
    description: 'Foursquare checkin component',
  },
  {
    id: '4075',
    name: 'Blip.fm',
    logo: '🎵',
    launchDate: '2007-01-01',
    endDate: '2013-09-17',
    description: 'Micro-blogging for music lovers',
  },
  {
    id: '4076',
    name: 'LinkedIn Slideshare',
    logo: '📊',
    launchDate: '2006-10-04',
    endDate: '2012-09-19',
    description: 'Presentation sharing platform',
  },
  {
    id: '4077',
    name: 'Klout',
    logo: '📈',
    launchDate: '2008-08-01',
    endDate: '2018-09-24',
    description: 'Social media influence scoring service',
  },
  {
    id: '4078',
    name: 'Tiny URL Shortener',
    logo: '🔗',
    launchDate: '2002-01-01',
    endDate: '2013-09-25',
    description: 'URL shortening and tracking service',
  },
  {
    id: '4079',
    name: 'Pottermore Beta',
    logo: '🪄',
    launchDate: '2011-09-01',
    endDate: '2013-09-29',
    description: 'Harry Potter digital experience platform',
  },
  {
    id: '4080',
    name: 'Zynga Farmville Original',
    logo: '🚜',
    launchDate: '2009-06-19',
    endDate: '2016-10-01',
    description: 'Social farming game on Facebook',
  },
  {
    id: '4081',
    name: 'Disqus Legacy Comments',
    logo: '💬',
    launchDate: '2007-08-15',
    endDate: '2013-10-02',
    description: 'Comment hosting and community platform',
  },
  {
    id: '4082',
    name: 'GetGlue',
    logo: '✓',
    launchDate: '2007-09-15',
    endDate: '2014-10-03',
    description: 'TV show and movie social check-in app',
  },
  {
    id: '4083',
    name: 'Tweetdeck (original)',
    logo: '🐦',
    launchDate: '2008-04-01',
    endDate: '2013-10-09',
    description: 'Twitter dashboard and management client',
  },
  {
    id: '4084',
    name: 'Uproar',
    logo: '📢',
    launchDate: '1997-01-01',
    endDate: '2009-10-15',
    description: 'Online gaming and communities',
  },
  {
    id: '4085',
    name: 'Flickr Uploadr',
    logo: '📸',
    launchDate: '2004-02-01',
    endDate: '2012-10-20',
    description: 'Photo uploading tool for Flickr',
  },
  {
    id: '4086',
    name: 'Eventful',
    logo: '🎉',
    launchDate: '2003-03-01',
    endDate: '2014-10-21',
    description: 'Event discovery and calendar service',
  },
  {
    id: '4087',
    name: 'Gowalla',
    logo: '📍',
    launchDate: '2009-07-14',
    endDate: '2012-10-26',
    description: 'Location-based game and check-in service',
  },
  {
    id: '4088',
    name: 'Last.fm Scrobbler',
    logo: '🎵',
    launchDate: '2002-04-01',
    endDate: '2014-10-29',
    description: 'Music scrobbling and recommendation service',
  },
  {
    id: '4089',
    name: 'Yahoo Shine',
    logo: '✨',
    launchDate: '2006-06-01',
    endDate: '2014-11-01',
    description: 'Lifestyle and women-focused content portal',
  },
  {
    id: '4090',
    name: 'Slated',
    logo: '📽️',
    launchDate: '2004-09-15',
    endDate: '2010-11-02',
    description: 'Movie and entertainment social network',
  },
  {
    id: '4091',
    name: 'Buzzfeed Video Legacy',
    logo: '📺',
    launchDate: '2006-11-15',
    endDate: '2015-11-08',
    description: 'Viral video content platform',
  },
  {
    id: '4092',
    name: 'Quora Beta',
    logo: '❓',
    launchDate: '2009-09-25',
    endDate: '2013-11-09',
    description: 'Question-and-answer community platform',
  },
  {
    id: '4093',
    name: 'MOG Music',
    logo: '🎶',
    launchDate: '2006-09-01',
    endDate: '2013-11-10',
    description: 'Music streaming service acquired by Beats',
  },
  {
    id: '4094',
    name: 'Yahoo Axis',
    logo: '📈',
    launchDate: '2009-10-16',
    endDate: '2011-11-13',
    description: 'Social search engine',
  },
  {
    id: '4095',
    name: 'Windows Live OneCare',
    logo: '🛡️',
    launchDate: '2005-05-31',
    endDate: '2009-11-14',
    description: 'Computer security and optimization tool',
  },
  {
    id: '4096',
    name: 'Tivo Online',
    logo: '📺',
    launchDate: '2005-01-01',
    endDate: '2013-11-15',
    description: 'Television recording and streaming service',
  },
  {
    id: '4097',
    name: 'Thumbplay',
    logo: '👍',
    launchDate: '2012-06-01',
    endDate: '2016-11-16',
    description: 'Mobile music streaming service',
  },
  {
    id: '4098',
    name: 'Rdio',
    logo: '🎵',
    launchDate: '2010-09-07',
    endDate: '2015-11-17',
    description: 'Music streaming service acquired by Pandora',
  },
  {
    id: '4099',
    name: 'Expedia Bookings',
    logo: '✈️',
    launchDate: '1995-10-01',
    endDate: '2012-11-23',
    description: 'Travel booking service legacy version',
  },
  {
    id: '4100',
    name: 'Pandora Ticketfly',
    logo: '🎫',
    launchDate: '2012-10-01',
    endDate: '2020-11-24',
    description: 'Event ticketing platform',
  },
  {
    id: '4101',
    name: 'Yahoo Shine Fashion',
    logo: '👗',
    launchDate: '2009-02-01',
    endDate: '2014-11-28',
    description: 'Fashion content and shopping',
  },
  {
    id: '4102',
    name: 'Coxswain',
    logo: '🚣',
    launchDate: '2011-02-01',
    endDate: '2013-11-29',
    description: 'Sports streaming service',
  },
  {
    id: '4103',
    name: 'CrunchBase Early',
    logo: '💼',
    launchDate: '2007-09-18',
    endDate: '2012-11-30',
    description: 'Startup database and community',
  },
  {
    id: '4104',
    name: 'Yahoo Shine Health',
    logo: '🏥',
    launchDate: '2006-01-01',
    endDate: '2014-12-01',
    description: 'Health and wellness content',
  },
  {
    id: '4105',
    name: 'Spotify URI',
    logo: '🎵',
    launchDate: '2006-04-23',
    endDate: '2019-12-03',
    description: 'Music streaming app (original protocol)',
  },
  {
    id: '4106',
    name: 'Anchor FM Legacy',
    logo: '🎙️',
    launchDate: '2014-04-01',
    endDate: '2019-12-04',
    description: 'Podcast hosting and creation platform',
  },
  {
    id: '4107',
    name: 'BuzzBonus',
    logo: '⭐',
    launchDate: '2009-08-01',
    endDate: '2013-12-05',
    description: 'Rewards and engagement platform',
  },
  {
    id: '4108',
    name: 'Scribd Texts',
    logo: '📖',
    launchDate: '2007-05-01',
    endDate: '2015-12-07',
    description: 'Document sharing and publishing',
  },
  {
    id: '4109',
    name: 'Goodreads Choice Awards',
    logo: '📚',
    launchDate: '2008-12-01',
    endDate: '2020-12-08',
    description: 'Book voting and recommendation service',
  },
  {
    id: '4110',
    name: 'Hootsuite Insights',
    logo: '📊',
    launchDate: '2008-07-01',
    endDate: '2014-12-10',
    description: 'Social media analytics platform',
  },
  {
    id: '4111',
    name: 'Ask.com Beta',
    logo: '❓',
    launchDate: '1996-09-15',
    endDate: '2012-12-13',
    description: 'Question-based search engine',
  },
  {
    id: '4112',
    name: 'Topsy Analytics',
    logo: '📈',
    launchDate: '2006-05-15',
    endDate: '2016-12-14',
    description: 'Social media search and analytics',
  },
  {
    id: '4113',
    name: 'Pingo Voice',
    logo: '📞',
    launchDate: '2005-05-01',
    endDate: '2011-12-15',
    description: 'VoIP calling service',
  },
  {
    id: '4114',
    name: 'TechCrunch Disrupt',
    logo: '🚀',
    launchDate: '2009-09-07',
    endDate: '2020-12-16',
    description: 'Startup conference and hackathon event series',
  },
  {
    id: '4115',
    name: 'Aviary Image Editor',
    logo: '🎨',
    launchDate: '2008-05-01',
    endDate: '2015-12-17',
    description: 'Online image editing suite',
  },
  {
    id: '4116',
    name: 'StockTwits',
    logo: '📈',
    launchDate: '2009-10-01',
    endDate: '2015-12-18',
    description: 'Stock market community platform',
  },
  {
    id: '4117',
    name: 'Carbon Ads',
    logo: '🌍',
    launchDate: '2010-01-15',
    endDate: '2018-12-19',
    description: 'Ethical advertising network',
  },
  {
    id: '4118',
    name: 'Gigya',
    logo: '🔐',
    launchDate: '2005-01-01',
    endDate: '2020-12-20',
    description: 'Customer identity and access management platform',
  },
  {
    id: '4119',
    name: 'Mashery API',
    logo: '🔌',
    launchDate: '2006-08-10',
    endDate: '2016-12-22',
    description: 'API management platform',
  },
  {
    id: '4120',
    name: 'Yahoo Mail Classic',
    logo: '📧',
    launchDate: '1997-10-08',
    endDate: '2013-12-24',
    description: 'Email service original interface',
  },
  {
    id: '4121',
    name: 'Google Spaces',
    logo: '📝',
    launchDate: '2016-03-08',
    endDate: '2018-12-25',
    description: 'Collaborative space for collecting and sharing content',
  },
  {
    id: '4122',
    name: 'Periscope Live Streams',
    logo: '📹',
    launchDate: '2015-03-26',
    endDate: '2020-12-27',
    description: 'Live video streaming platform by Twitter',
  },
  {
    id: '4123',
    name: 'Vine Video App',
    logo: '🎬',
    launchDate: '2013-01-24',
    endDate: '2017-12-28',
    description: '6-second video sharing platform',
  },
  {
    id: '4124',
    name: 'Meerkat Live',
    logo: '🦁',
    launchDate: '2015-02-17',
    endDate: '2016-12-29',
    description: 'Live video streaming app',
  },
  {
    id: '4125',
    name: 'Yahoo Directory Final',
    logo: '📚',
    launchDate: '1994-02-01',
    endDate: '2014-12-30',
    description: 'Web directory final shutdown',
  },
  {
    id: '4126',
    name: 'TinyURL',
    logo: '🔗',
    launchDate: '2002-01-01',
    endDate: '2018-12-31',
    description: 'URL shortening service end of service',
  },
  // Additional entries for remaining MM-DD combinations
  {
    id: '4127',
    name: 'Apple QuickTime X',
    logo: '🎬',
    launchDate: '2008-10-28',
    endDate: '2016-02-29',
    description: 'QuickTime media player on macOS',
  },
  {
    id: '4128',
    name: 'Windows Media Services',
    logo: '📡',
    launchDate: '1999-01-01',
    endDate: '2015-04-23',
    description: 'Media streaming server service',
  },
  {
    id: '4129',
    name: 'Yahoo Toolbar',
    logo: '🔧',
    launchDate: '2001-11-01',
    endDate: '2012-04-25',
    description: 'Browser toolbar for Yahoo services',
  },
  {
    id: '4130',
    name: 'Google Desktop Search',
    logo: '🔍',
    launchDate: '2004-10-14',
    endDate: '2012-04-26',
    description: 'Desktop file and email search tool',
  },
  {
    id: '4131',
    name: 'Microsoft Office Tab',
    logo: '📋',
    launchDate: '2006-09-01',
    endDate: '2011-04-28',
    description: 'Tabbed interface for Office documents',
  },
  {
    id: '4132',
    name: 'Adobe ExtendScript',
    logo: '🔧',
    launchDate: '2003-01-01',
    endDate: '2020-04-29',
    description: 'Scripting language for Adobe products',
  },
  {
    id: '4133',
    name: 'Windows SideShow',
    logo: '📟',
    launchDate: '2007-01-30',
    endDate: '2015-08-04',
    description: 'Secondary display device technology',
  },
  {
    id: '4134',
    name: 'Openwave Mobile Browser',
    logo: '📱',
    launchDate: '2001-06-01',
    endDate: '2011-08-21',
    description: 'Mobile web browser',
  },
  {
    id: '4135',
    name: 'Microsoft VC++',
    logo: '💻',
    launchDate: '1993-02-01',
    endDate: '2018-08-26',
    description: 'C++ compiler for Windows',
  },
  {
    id: '4136',
    name: 'Google Wallet',
    logo: '💳',
    launchDate: '2011-09-19',
    endDate: '2015-09-04',
    description: 'Mobile payment service',
  },
  {
    id: '4137',
    name: 'Adobe LiveCycle',
    logo: '🔄',
    launchDate: '2002-07-01',
    endDate: '2017-09-07',
    description: 'Form and document processing platform',
  },
  {
    id: '4138',
    name: 'Yahoo Mail API',
    logo: '📧',
    launchDate: '2004-08-01',
    endDate: '2014-09-20',
    description: 'Email service API access',
  },
  {
    id: '4139',
    name: 'Windows HyperTerminal',
    logo: '⌨️',
    launchDate: '1998-04-01',
    endDate: '2010-09-21',
    description: 'Terminal emulation software',
  },
  {
    id: '4140',
    name: 'Google Gears for Mobile',
    logo: '⚙️',
    launchDate: '2007-05-30',
    endDate: '2011-09-22',
    description: 'Mobile offline web support',
  },
  {
    id: '4141',
    name: 'Symbian UIQ',
    logo: '📱',
    launchDate: '2001-01-01',
    endDate: '2009-10-06',
    description: 'User interface for Symbian phones',
  },
  {
    id: '4142',
    name: 'Microsoft BASIC',
    logo: '💻',
    launchDate: '1981-08-01',
    endDate: '2008-10-07',
    description: 'Programming language interpreter',
  },
  {
    id: '4143',
    name: 'Adobe Scene7',
    logo: '🎬',
    launchDate: '2000-01-01',
    endDate: '2016-10-11',
    description: 'Rich media management platform',
  },
  {
    id: '4144',
    name: 'Yahoo People Search',
    logo: '👥',
    launchDate: '1999-01-01',
    endDate: '2013-10-13',
    description: 'People directory search service',
  },
  {
    id: '4145',
    name: 'Windows DirectDraw',
    logo: '🎮',
    launchDate: '1995-08-01',
    endDate: '2012-10-16',
    description: 'Graphics API for games',
  },
  {
    id: '4146',
    name: 'Google Alerts Original',
    logo: '🚨',
    launchDate: '2003-11-01',
    endDate: '2015-10-17',
    description: 'Email notification service for search results',
  },
  {
    id: '4147',
    name: 'Adobe ColdFusion',
    logo: '🧊',
    launchDate: '1995-07-01',
    endDate: '2020-10-19',
    description: 'Web application server',
  },
  {
    id: '4148',
    name: 'Yahoo Personalization',
    logo: '⚙️',
    launchDate: '2000-01-01',
    endDate: '2012-10-22',
    description: 'Custom homepage service',
  },
  {
    id: '4149',
    name: 'Microsoft DirectPlay',
    logo: '🎮',
    launchDate: '1997-04-01',
    endDate: '2013-10-24',
    description: 'Multiplayer gaming API',
  },
  {
    id: '4150',
    name: 'Google Analytics 360',
    logo: '📊',
    launchDate: '2005-11-01',
    endDate: '2015-10-25',
    description: 'Enterprise analytics platform',
  },
  {
    id: '4151',
    name: 'Adobe Robohelp',
    logo: '📚',
    launchDate: '1996-01-01',
    endDate: '2019-10-27',
    description: 'Help authoring tool',
  },
  {
    id: '4152',
    name: 'Yahoo Local Services',
    logo: '🗺️',
    launchDate: '2002-01-01',
    endDate: '2013-10-28',
    description: 'Local business directory',
  },
  {
    id: '4153',
    name: 'Windows DirectSound',
    logo: '🔊',
    launchDate: '1995-08-01',
    endDate: '2014-11-03',
    description: 'Audio API for games',
  },
  {
    id: '4154',
    name: 'Google Webmaster Central',
    logo: '🔧',
    launchDate: '2006-06-01',
    endDate: '2015-11-04',
    description: 'Website optimization tools',
  },
  {
    id: '4155',
    name: 'Adobe Contribute CS',
    logo: '✏️',
    launchDate: '2003-07-01',
    endDate: '2016-11-06',
    description: 'Content management software',
  },
  {
    id: '4156',
    name: 'Yahoo Site Explorer',
    logo: '🔍',
    launchDate: '2005-08-01',
    endDate: '2012-11-11',
    description: 'SEO and backlink analysis tool',
  },
  {
    id: '4157',
    name: 'Windows DirectMusic',
    logo: '🎵',
    launchDate: '1996-03-01',
    endDate: '2014-11-18',
    description: 'MIDI music API',
  },
  {
    id: '4158',
    name: 'Google Sitemap Protocol',
    logo: '🗺️',
    launchDate: '2005-06-01',
    endDate: '2016-11-21',
    description: 'XML sitemap standard',
  },
  {
    id: '4159',
    name: 'Adobe LiveMotion',
    logo: '🎬',
    launchDate: '1999-12-01',
    endDate: '2007-11-22',
    description: 'Vector animation tool',
  },
  {
    id: '4160',
    name: 'Yahoo Video Search',
    logo: '🎥',
    launchDate: '2006-09-01',
    endDate: '2013-11-26',
    description: 'Video search engine',
  },
  {
    id: '4161',
    name: 'Windows DirectInput',
    logo: '🎮',
    launchDate: '1996-06-01',
    endDate: '2014-11-27',
    description: 'Input device API',
  },
  {
    id: '4162',
    name: 'Google Mobile Search',
    logo: '📱',
    launchDate: '2005-12-01',
    endDate: '2016-12-02',
    description: 'Mobile web search results',
  },
  {
    id: '4163',
    name: 'Adobe Shockwave Cast',
    logo: '🌊',
    launchDate: '1996-10-01',
    endDate: '2015-12-12',
    description: 'Shockwave media distribution',
  },
  {
    id: '4164',
    name: 'Yahoo Image Search Classic',
    logo: '🖼️',
    launchDate: '1997-04-01',
    endDate: '2014-12-23',
    description: 'Image search engine',
  },
];
